export const commonTranslations = {
  fr: {
    loading: 'Chargement...',
    loadingPage: 'Chargement de la page...',
    error: 'Erreur',
    cached: 'En cache',
    searchCount: '{{count}} recherches',
    back: 'Retour',
    all: 'Tous',
    save: 'Enregistrer',
    select: 'Sélectionner',
    delete: 'Supprimer',
    xpEarned: '{{xp}} XP gagnés',
    connectionRestored: "Connexion rétablie",
    offlineModeActive: "Mode hors-ligne activé",
    limitedFunctionsAvailable: "Fonctions limitées disponibles",
    actionSavedOffline: "Action sauvegardée hors-ligne",
    offlineDataSynced: "{{count}} action(s) hors-ligne synchronisée(s)",
    syncFailed: "Échec de la synchronisation",
    syncingOfflineData: "Synchronisation des données hors-ligne",
    offlineDataPending: "Données hors-ligne en attente de synchronisation",
    syncNow: "Synchroniser",
    expandAll: "Tout déployer",
    collapseAll: "Tout réduire",
    edit: "Éditer",
    search: "Recherche",
    searchInApp: "Rechercher dans l'application",
    preview: "Aperçu",
    saved: "Enregistré",
    saving: "Enregistrement...",
    savedOffline: "Enregistré hors ligne",
    lastSaved: "Dernière sauvegarde: {{time}}",
    backToDashboard: "Retour au tableau de bord",
    home: "Accueil",
    menu: "Menu",
    notificationsLabel: "Notifications",
    nav: {
      dashboard: 'Tableau de bord',
      checklists: 'Checklists'
    },
    settingsMenu: {
      settings: 'Paramètres',
      administration: 'Administration',
      themeLight: 'Thème clair',
      themeDark: 'Thème sombre',
      themeSystem: 'Thème système',
      logout: 'Déconnexion',
    },
    sidebar: {
      dashboard: 'Tableau de bord',
      chatAI: 'Chat IA',
      flashcards: 'Flashcards',
      revisionSheets: 'Fiches de révision',
      dailyQuiz: 'Quiz du jour',
      study: 'Étude',
      courses: 'Cours',
      clinicalCases: 'Cas cliniques',
      challenges: 'Défis',
      revisionExpress: 'Révision Express',
      calculators: 'Calculateurs',
      checklists: 'Checklists',
      medications: 'Médicaments',
      coding: 'Codage',
      guidelines: 'Guidelines',
      forum: 'Forum',
      scores: 'Scores',
      achievements: 'Achievements',
      hallOfFame: 'Hall of Fame',
      settings: 'Paramètres',
      groupMain: 'Principal',
      groupLearning: 'Apprentissage',
      groupTools: 'Outils cliniques',
      groupCommunity: 'Communauté',
    },
    units: {
      minutes: 'min',
      days: 'j',
      cards: 'cartes'
    },
    requiredName: {
      title: '👋 Comment vous appelez-vous ?',
      description: 'Votre nom sera affiché dans le Hall of Fame et la communauté. Cette information est obligatoire pour continuer.',
      placeholder: 'Dr. Prénom Nom',
      minChars: 'Minimum 3 caractères',
      continue: 'Continuer'
    },
    preparingOfflineContent: "Préparation du contenu hors ligne",
    offlineContentReady: "Contenu hors ligne prêt",
    downloadOfflineContent: "Télécharger le contenu hors ligne",
    downloadingEssentialContent: "Téléchargement du contenu essentiel...",
    appReadyOffline: "Application prête pour une utilisation hors ligne",
    enableOfflineAccess: "Activer l'accès hors ligne",
    connectToDownload: "Connectez-vous pour télécharger",
    downloadComplete: "Téléchargement terminé",
    essentialContentCached: "Contenu essentiel mis en cache",
    downloadFailed: "Échec du téléchargement",
    offlineContent: "Contenu hors ligne",
    cachedItems: "Éléments en cache",
    storageUsed: "Stockage utilisé",
    offlineStatus: "État hors ligne",
    ready: "Prêt",
    notReady: "Pas prêt",
    cachedContent: "Contenu en cache",
    manageOfflineContent: "Gérer le contenu hors ligne",
    downloadEssentials: "Télécharger l'essentiel",
    cleanupOld: "Nettoyer l'ancien",
    clearAll: "Tout effacer",
    offlineDownloadUnavailable: "Téléchargement indisponible en mode hors ligne",
    cacheCleared: "Cache vidé",
    offlineContentRemoved: "Contenu hors ligne supprimé",
    clearFailed: "Échec du nettoyage",
    cleanupComplete: "Nettoyage terminé",
    oldContentRemoved: "Ancien contenu supprimé",
    cleanupFailed: "Échec du nettoyage",
    tryAgainLater: "Réessayez plus tard",
    cancel: "Annuler",
    closeDialog: "Fermer la boîte de dialogue",
    close: "Fermer",
    camera: {
      capture: "Capturer",
      takePhoto: "Prendre une photo",
      photoCapture: "Capture de photo"
    },
    copied: "Copié !",
    copyError: "Impossible de copier",
    shareButton: 'Partager',
    export: 'Exporter',
    shared: 'Partagé ✓',
    copy: 'Copier',
    later: 'Plus tard',
    pricing: 'Tarifs',
    success: 'Succès',
    shareExploit: 'Partagez votre exploit avec vos collègues !',
    pwa: {
      howToInstall: "Comment installer l'application :",
      iosInstall: 'Installation sur Safari iOS',
      iosTroubleshoot: 'Si les boutons ne répondent pas, essayez ces solutions :',
      tapShare: 'Appuyez sur le bouton Partager',
      bottomSafari: "En bas de l'écran dans Safari",
      addHomeScreen: 'Faites défiler et sélectionnez "Sur l\'écran d\'accueil"',
      scrollDown: 'Faites défiler vers le bas dans la liste des options',
      tapAdd: 'Appuyez sur "Ajouter" pour confirmer',
      stillNotWorking: 'Si ça ne fonctionne toujours pas :',
      refreshPage: 'Actualisez la page (glissez vers le bas)',
      restartSafari: 'Redémarrez Safari complètement',
      checkSafari: 'Vérifiez que vous êtes sur Safari (pas Chrome iOS)',
      tryPrivate: 'Essayez en mode navigation privée',
      iconWillAppear: "L'icône Sclepios apparaîtra sur votre écran d'accueil !",
      tapMenu: 'Appuyez sur le menu (3 points)',
      selectInstall: 'Sélectionnez "Installer l\'application" ou "Ajouter à l\'écran d\'accueil"',
      confirmInstall: "Confirmez l'installation",
      quickAccess: "Accès rapide depuis votre écran d'accueil !",
      iosInstructionAlert: 'Pour installer l\'app: Appuyez sur le bouton de partage puis "Ajouter à l\'écran d\'accueil"',
      androidInstructionAlert: 'Pour installer l\'app: Ouvrez le menu du navigateur puis "Ajouter à l\'écran d\'accueil"',
      unsupported: "Votre navigateur ne supporte pas l'installation d'applications web",
      installSclepios: 'Installer Sclépios',
      installSclepiosAI: 'Installer Sclépios IA',
      quickAccessNotifications: 'Accès rapide et notifications',
      install: 'Installer',
      installNow: 'Installer maintenant',
      installDesktopDesc: "Installez l'application pour un accès rapide et des notifications.",
      dontShowAgain: 'Ne plus afficher'
    },
    followUrgentiste: "Suivez l'Urgentiste masqué :",
    availableCases: 'Cas cliniques disponibles',
    exploreCases: 'Explorez des cas cliniques authentiques et leurs prises en charge détaillées',
    searchCases: 'Rechercher par mot-clé, tag ou pathologie...',
    casesFound: '{{count}} cas trouvé(s) pour "{{term}}"',
    unexpectedError: "Une erreur est survenue",
    checkingPermissions: "Vérification des autorisations...",
    backToHome: "Retour à l'accueil",
    system: "Système",
    saveError: "Erreur lors de la sauvegarde",
    usageLoadError: "Erreur lors du chargement de votre usage",
    backgroundTasks: {
      launchError: "Impossible de lancer la génération",
      generating: "en cours de génération...",
      navigateFreely: "Vous pouvez naviguer librement",
      aiGenerating: "Générations IA en cours",
      flashcards: "Flashcards",
      revisionSheet: "Fiche de révision",
      qcm: "QCM",
      clinicalCase: "Cas clinique",
      processing: "en cours",
      pending: "en attente",
    },
    onboarding: {
      completeProfile: "Veuillez compléter votre profil pour continuer",
      welcomeSuccess: "Bienvenue ! Votre profil a été configuré avec succès.",
      saveError: "Erreur lors de la sauvegarde du profil",
      configTitle: "Configuration de votre profil",
      configDesc: "Personnalisez votre expérience Sclepios",
      previous: "Précédent",
      skip: "Passer",
      profileRequired: "Profil requis",
      next: "Suivant",
      finalizing: "Finalisation...",
      finish: "Terminer",
      readyToStart: "Prêt à commencer !",
      readyDesc: "Vous êtes maintenant prêt à utiliser toutes les fonctionnalités de Sclepios.",
      medicalAI: "IA Médicale",
      adaptiveQuiz: "Quiz adaptatifs",
      steps: {
        profile: { title: "Profil professionnel", desc: "Aidez-nous à personnaliser votre expérience", fullName: "Nom complet", fullNamePlaceholder: "Votre nom complet", userType: "Type d'utilisateur", selectProfession: "Sélectionnez votre profession" },
        practice: { title: "Mode d'exercice", desc: "Décrivez votre environnement de travail", mode: "Mode d'exercice", selectMode: "Sélectionnez votre mode d'exercice", specialty: "Spécialité", selectSpecialty: "Sélectionnez votre spécialité" },
        service: { title: "Service", desc: "Dans quel service exercez-vous ?", label: "Service", selectService: "Sélectionnez votre service" },
        preferences: { title: "Préférences", desc: "Personnalisez votre expérience", notifications: "Notifications", notificationsDesc: "Recevez des notifications pour vos flashcards et rappels", tips: "Conseils et astuces", tipsDesc: "Recevez des conseils pour optimiser votre utilisation", newsletterDesc: "Recevez notre newsletter mensuelle avec les nouveautés" }
      },
      welcomeTitle: '🎉 Bienvenue sur Sclépios !',
      welcomeDesc: 'Votre assistant IA médical personnel',
      firstStepBadge: 'Premier Pas',
      chatTitle: '💬 Posez votre première question',
      chatDesc: "Testez l'IA médicale maintenant",
      creatorBadge: 'Créateur',
      startIn30s: 'Commencez en 30 secondes',
      tellUsWho: 'Dites-nous qui vous êtes',
      yourName: 'Votre nom *',
      specialtyOptional: 'Spécialité (optionnel)',
      specialtyPlaceholder: 'Urgences, Médecine générale...',
      rewards: 'Récompenses',
      congrats: 'Félicitations {{name}} ! 🎉',
      badgeEarned: 'Vous avez débloqué le badge "Premier Pas" et gagné 50 XP !',
      welcomeToast: '🎉 Bienvenue ! Vous avez gagné 50 XP !',
      badgeUnlocked: 'Badge "Premier Pas" débloqué',
      readyForQuestion: 'Prêt pour votre première question ?',
      askAnything: "Posez n'importe quelle question médicale à l'IA",
      example1: "Quels sont les signes d'alerte d'un infarctus ?",
      example2: "Protocole de prise en charge d'une détresse respiratoire",
      example3: 'Créer des flashcards sur la cardiologie',
      tip: '💡 Astuce : Vous gagnerez 100 XP et le badge "Créateur" après votre première conversation !',
      continue: 'Continuer',
      askFirstQuestion: 'Poser ma première question'
    },
    nameSaved: "Nom enregistré !",
    registrationError: "Erreur lors de l'enregistrement",
    enterName: "Veuillez entrer votre nom",
    invalidEmail: "Veuillez entrer une adresse email valide",
    enterDifferentEmail: "Veuillez entrer une nouvelle adresse email différente",
    emailConfirmSent: "Un email de confirmation a été envoyé à votre nouvelle adresse. Veuillez cliquer sur le lien pour confirmer le changement.",
    emailChangeError: "Erreur lors du changement d'email",
    referralCopied: "Lien de parrainage copié !",
    challengeJoined: "Vous avez rejoint le challenge !",
    challengeJoinError: "Impossible de rejoindre le challenge",
    selectReason: "Veuillez sélectionner une raison",
    userBanned: "Utilisateur banni avec succès",
    banError: "Erreur lors du bannissement",
    postDeleted: "Post supprimé",
    replyDeleted: "Réponse supprimée",
    deleteError: "Erreur lors de la suppression",
    contentHidden: "Contenu masqué",
    hideError: "Erreur lors du masquage",
    promptCreated: "Prompt créé avec succès",
    promptCreateError: "Erreur lors de la création du prompt",
    promptUpdated: "Prompt mis à jour avec succès",
    promptUpdateError: "Erreur lors de la mise à jour du prompt",
    promptArchived: "Prompt archivé",
    promptArchiveError: "Erreur lors de l'archivage",
    promptDeleteError: "Erreur lors de la suppression",
    metricsLoadError: "Erreur lors du chargement des métriques",
    notifications: {
      streakDanger: "Ton streak est en danger ! 🔥",
      streakDangerDesc: "Tu n'as pas révisé depuis 2 jours. Continue ta série maintenant !",
      review: "Réviser",
      newGuideline: "Nouvelle guideline disponible 📚",
      guidelineDesc: "{{count}} nouvelle(s) recommandation(s) dans {{specialty}}",
      see: "Voir",
      top5: "Tu es dans le top 5 ! 🏆",
      top5Desc: "Position #{{position}} sur le classement cette semaine",
      newBadge: "Nouveau badge débloqué ! 🎉",
      referralSuccess: "Un collègue a rejoint Sclépios grâce à toi ! 🎉",
      referralDesc: "Merci pour le parrainage ! Continue à partager."
    },
    patients: {
      loadError: "Erreur lors du chargement des patients",
      loadOneError: "Erreur lors du chargement du patient",
      saveError: "Erreur lors de la sauvegarde",
      updated: "Patient mis à jour",
      created: "Patient créé",
      deleted: "Patient supprimé",
      deleteError: "Erreur lors de la suppression"
    },
    photo: {
      unsupportedFormat: "Format d'image non supporté. Utilisez PNG, JPEG, WEBP ou GIF.",
      tooLarge: "L'image est trop volumineuse. Taille maximale : 50MB.",
      textDetected: "Texte détecté dans l'image !",
      imageAdded: "Image ajoutée - aucun texte détecté",
      processingError: "Erreur lors du traitement de l'image",
      selectImage: "Veuillez sélectionner un fichier image",
      cameraError: "Erreur lors du traitement de la photo",
      takePhoto: "Prendre une photo",
      selectFromGallery: "Sélectionner une image"
    },
    documents: {
      unsupportedType: "Type de fichier non supporté. Utilisez JPG, PNG, WebP, PDF, TXT ou DOCX.",
      tooLarge: "Fichier trop volumineux. Maximum 10MB par fichier.",
      maxFiles: "Maximum 5 fichiers autorisés",
      selectAtLeast: "Veuillez sélectionner au moins un document",
      ocrNoText: "OCR terminé mais aucun texte détecté dans les images",
      noTextDetected: "Aucun texte détecté dans les documents. Vérifiez la qualité et essayez \"Forcer OCR PDF\" si nécessaire.",
      photoCaptured: "Photo capturée avec succès!",
      readError: "Erreur lors de la lecture du fichier {{name}}",
      ocrSuccess: "OCR terminé: texte extrait de {{count}} image(s)",
      extractionComplete: "Extraction terminée. {{count}} fichier(s) traité(s).",
      importTitle: "Import de documents",
      importDesc: "Importez vos documents pour extraire automatiquement le texte",
      captureTitle: "Capture de documents",
      captureDesc: "Prenez en photo ou sélectionnez des documents médicaux (images, PDF, TXT, DOCX)",
      takePhoto: "Prendre une photo",
      selectFiles: "Sélectionner des fichiers",
      extracting: "Extraction du texte en cours...",
      extractText: "Extraire le texte ({{count}} fichier{{plural}})",
      formatsSupported: "Formats supportés: JPG, PNG, WebP, PDF, TXT, DOCX (max 10MB par fichier)",
      maxFilesInfo: "Maximum 5 fichiers par traitement",
      pdfInfo: "PDF: détection automatique du texte • Images: OCR haute qualité • TXT/DOCX: extraction directe",
      pdfDetected: "PDF lisible détecté: {{count}} caractères extraits",
      pdfProcessError: "Impossible de traiter le fichier PDF",
      processingPdf: "Traitement du PDF: {{name}}...",
      pdfToOcr: "PDF converti en images pour OCR: {{count}} page(s)",
      extractingImages: "Extraction du texte de {{count}} image(s)...",
      ocrError: "Erreur OCR: {{message}}",
      forcePdfOcr: "PDF scannés ou de mauvaise qualité ? Cochez \"Forcer OCR PDF\""
    },
    profile: {
      streakDays: "Jours de série",
      badges: "Badges",
      shareProfile: "Partager ce profil",
      joinSclepios: "Rejoignez Sclépios IA",
      joinDesc: "L'assistant médical intelligent pour les professionnels de santé",
      createFreeAccount: "Créer un compte gratuit",
      signoutError: "Erreur lors de la déconnexion"
    },
    admin: {
      costAlerts: {
        title: "Alertes de Coûts",
        description: "Surveillance en temps réel des coûts et ROI",
        testAlert: "Alerte de test envoyée",
        testAlertError: "Erreur lors de l'envoi de l'alerte test",
        monthlyRevenue: "Revenu Mensuel",
        aiCosts: "Coûts IA",
        margin: "Marge",
        noAlerts: "Aucune alerte active",
        allNormal: "Tous les indicateurs sont dans les limites normales",
        refresh: "Actualiser"
      },
      quickActions: {
        createTemplate: "Créer un template rapide",
        templateName: "Nom du template",
        templateType: "Type",
        templateSubject: "Sujet",
        templateContent: "Contenu",
        templatePlaceholder: "Contenu du template...",
        createBtn: "Créer le template",
        expressCampaign: "Campagne express",
        targetAudience: "Audience cible",
        allUsers: "Tous les utilisateurs",
        doctors: "Médecins",
        residents: "Résidents",
        nurses: "Infirmiers",
        emailSubject: "Sujet",
        emailMessage: "Message",
        emailPlaceholder: "Contenu du message...",
        sendNow: "Envoyer maintenant",
        systemActions: "Actions système",
        clearCache: "Vider le cache",
        securityAudit: "Audit de sécurité",
        refresh: "Actualiser",
        success: "Succès",
        templateCreated: "Template créé avec succès",
        templateCreateError: "Impossible de créer le template",
        fillFields: "Veuillez remplir le sujet et le contenu",
        campaignSent: "Campagne envoyée ! {{count}} destinataires",
        campaignSendError: "Impossible d'envoyer la campagne",
        cacheCleared: "Cache vidé avec succès",
        cacheClearError: "Impossible de vider le cache",
        auditComplete: "Audit terminé - Vérifiez les logs pour les détails",
        auditError: "Impossible d'exécuter l'audit de sécurité"
      },
      pushTest: {
        title: "Test de notifications push",
        description: "Envoyez des notifications push de test",
        notifTitle: "Titre",
        notifMessage: "Message",
        targetUser: "User ID cible (optionnel)",
        targetPlaceholder: "Laisser vide pour tous les utilisateurs",
        sending: "Envoi en cours...",
        sendNotif: "Envoyer la notification",
        titlePlaceholder: "Titre de la notification",
        messagePlaceholder: "Corps de la notification"
      },
      usageStats: {
        period: "Période",
        last24h: "Dernières 24h",
        last7days: "7 derniers jours",
        last30days: "30 derniers jours",
        last90days: "90 derniers jours",
        allTime: "Depuis le début",
        function: "Fonction",
        allFunctions: "Toutes les fonctions",
        loadingStats: "Chargement des statistiques..."
      },
      sendSamples: {
        pageTitle: "Admin · Envoi d'emails de prévenance",
        title: "Envoi d'emails de prévenance",
        description: "Cette page déclenche l'envoi de 3 emails d'exemple (rappel d'essai, avertissement post-essai, winback) à {{to}}.",
        sent: "Emails d'exemple envoyés à {{to}}",
        error: "Erreur lors de l'envoi",
        status: "Statut"
      }
    },
    paywall: {
      conversationCount: { title: "Vous progressez rapidement ! 🚀", description: "Vous avez déjà eu {{count}} conversations avec Sclepios AI. Passez à Premium pour continuer sans limite." },
      longExchange: { title: "Discussion approfondie 💡", description: "Vous êtes en pleine réflexion clinique ! Avec Premium, continuez vos échanges sans interruption." },
      featureDiscovery: { title: "Fonctionnalité Premium 👑", description: "Débloquez tout le potentiel de Sclepios avec Premium.", descriptionWithSpecialty: "En tant que professionnel en {{specialty}}, débloquez tout le potentiel de Sclepios." },
      streakRisk: { title: "Protégez votre streak ! 🔥", description: "Votre série est en danger. Avec Premium, recevez des rappels intelligents pour ne jamais perdre votre progression." },
      features: {
        unlimitedConversations: "Conversations illimitées",
        clinicalCases: "Cas cliniques interactifs",
        advancedStats: "Statistiques avancées",
        unlimitedExchanges: "Échanges illimités",
        detailedAnswers: "Réponses plus détaillées",
        priorityAccess: "Accès prioritaire",
        allFeatures: "Toutes les fonctionnalités",
        advancedAI: "IA médicale avancée",
        optimizedProgress: "Progression optimisée",
        personalizedReminders: "Rappels personnalisés",
        detailedStats: "Statistiques détaillées",
        exclusiveBadges: "Badges exclusifs"
      },
      viewPremium: "Voir les offres Premium",
      continueFree: "Continuer gratuitement",
      trialInfo: "Essai gratuit de 7 jours • Annulation à tout moment"
    },
    patientEdit: {
      updated: "Informations patient mises à jour",
      updateError: "Erreur lors de la mise à jour",
      personalInfo: "Informations personnelles",
      years: "ans",
      sex: "Sexe",
      editTitle: "Modifier les informations patient",
      emergencyContact: "Personne de confiance",
      name: "Nom",
      relationship: "Lien",
      kinship: "Lien de parenté",
      kinshipPlaceholder: "Conjoint, Enfant, Parent...",
      lastName: "Nom",
      firstName: "Prénom",
      selectOption: "Sélectionner",
      male: "Masculin",
      female: "Féminin",
      other: "Autre",
      unspecified: "Non spécifié"
    },
    photoCapture: {
      cameraError: "Erreur lors de l'accès à la caméra",
      unsupportedFormat: "Format d'image non supporté. Veuillez utiliser JPG, PNG, GIF, WebP, HEIC, HEIF ou AVIF.",
      tooLarge: "Image trop volumineuse. Taille maximale: 10MB",
      invalidFormat: "Format de données invalide",
      extractSuccess: "Texte extrait avec succès ({{count}} caractères)",
      noTextDetected: "Aucun texte détecté dans l'image. Vérifiez que l'image contient du texte lisible.",
      extractError: "Erreur lors de l'extraction du texte",
      takePhoto: "Prendre une photo",
      selectImage: "Sélectionner une image"
    },
    structuredList: {
      newItem: "Nouvel élément",
      addItem: "Ajouter un élément"
    },
    share: {
      copiedToClipboard: "Copié dans le presse-papiers !",
      shareError: "Impossible de partager",
      quizTitle: "Quiz du jour — Sclépios IA",
      quizText: "🩺 J'ai obtenu {{percentage}}% ({{score}}/{{total}}) au Quiz du jour sur Sclépios IA ! Teste tes connaissances médicales 👇",
      streakTitle: "Série d'apprentissage — Sclépios IA",
      streakText: "{{emoji}} Série de {{days}} jours consécutifs sur Sclépios IA ! L'apprentissage médical, un jour à la fois 💪",
      badgeTitle: "Badge débloqué — Sclépios IA",
      badgeText: "🏅 J'ai débloqué le badge \"{{name}}\" sur Sclépios IA ! Rejoins la communauté médicale 🩺",
      revisionTitle: "Révision Express — Sclépios IA",
      revisionText: "⚡ Révision Express terminée : {{correct}}/{{total}} ({{accuracy}}%) sur Sclépios IA ! Mode express pour réviser efficacement 🧠",
      clinicalCaseTitle: "Cas Clinique — Sclépios IA",
      clinicalCaseText: "🏥 J'ai résolu le cas clinique \"{{title}}\" avec {{percentage}}% de bonnes réponses ({{score}}/{{total}}) sur Sclépios IA ! Entraîne-toi aussi 👇",
      revisionSheetTitle: "Fiche de révision — Sclépios IA",
      revisionSheetText: "📋 J'ai généré une fiche de révision \"{{title}}\" en {{specialty}} sur Sclépios IA ! L'IA au service de l'apprentissage médical 🩺",
      deckText: "📚 Découvre mon deck \"{{name}}\" ({{count}} cartes) sur Sclépios IA ! Révise efficacement avec les flashcards 🧠"
    },
    adminPages: {
      toasts: {
        usersLoadError: "Erreur lors du chargement des utilisateurs",
        unauthorized: "Action non autorisée",
        trialExtended: "Période d'essai prolongée de 7 jours",
        trialExtendError: "Erreur lors de la prolongation de l'essai",
        userDeleted: "Utilisateur supprimé avec succès",
        userDeleteError: "Erreur lors de la suppression de l'utilisateur",
        secretsOk: "✅ Tous les secrets sont configurés",
        auditError: "Erreur lors de l'exécution de l'audit",
        noMissingUsers: "Aucun utilisateur manquant détecté",
        recoverError: "Erreur lors de la récupération des utilisateurs",
        stripeSynced: "Données Stripe synchronisées",
        stripeSyncError: "Erreur lors de la synchronisation Stripe",
        featureInDev: "Fonctionnalité en développement"
      },
      users: {
        title: "Gestion des Utilisateurs",
        subtitle: "Gérez les comptes utilisateurs, rôles et permissions",
        accessDenied: "Accès non autorisé",
        restricted: "Accès restreint",
        noPermission: "Vous n'avez pas les permissions nécessaires pour accéder à cette page.",
        showDashboard: "Afficher",
        hideDashboard: "Masquer",
        dashboard: "Dashboard",
        refresh: "Actualiser",
        verifyConfig: "Vérifier config",
        warnInactive: "Avertir inactifs",
        deleteInactive: "Supprimer inactifs",
        userList: "Liste des utilisateurs",
        manageRolesDesc: "Gérez les rôles et permissions des utilisateurs",
        loadingUsers: "Chargement des utilisateurs...",
        noUsersFound: "Aucun utilisateur trouvé",
        noName: "Sans nom",
        user: "Utilisateur",
        role: "Rôle",
        profile: "Profil",
        subscription: "Abonnement",
        status: "Statut",
        registered: "Inscrit",
        actions: "Actions",
        expiresOn: "Expire le",
        expired: "Expiré",
        notDefined: "Non défini",
        revoke: "Révoquer",
        activate: "Activer",
        extend: "Prolonger",
        deleteUser: "Supprimer",
        deleteConfirmTitle: "Supprimer l'utilisateur",
        deleteConfirmDesc: "Êtes-vous sûr de vouloir supprimer cet utilisateur ? Cette action est irréversible.",
        cancel: "Annuler",
        auditTitle: "Audit des comptes utilisateurs",
        auditRefresh: "Rafraîchir",
        missingAccounts: "{{count}} compte(s) manquant(s) détecté(s)",
        noMissing: "Aucun compte manquant détecté",
        auditPending: "Audit en cours ou indisponible...",
        missingDesc: "Des utilisateurs n'apparaissent pas dans le listing car ils n'ont pas d'entrée healthcare_providers.",
        recoverAction: "Cliquez sur \"Récupérer\" pour les restaurer automatiquement.",
        recoverBtn: "Récupérer les utilisateurs manquants",
        allSynced: "✅ Tous les comptes utilisateurs sont correctement synchronisés.",
        clickRefresh: "ℹ️ Cliquez sur \"Rafraîchir\" pour exécuter l'audit des comptes.",
        promoCodes: "Codes promotionnels",
        activePromoCodes: "Codes promo actifs",
        promoDesc: "Gérez les codes de réduction pour vos utilisateurs",
        createCode: "Créer un code",
        noPromoCodes: "Aucun code promotionnel créé",
        promoComingSoon: "Cette fonctionnalité sera bientôt disponible",
        premiumFree: "Premium Gratuit",
        freeTrial: "Essai gratuit",
        trialExpired: "Essai expiré",
        free: "Gratuit",
        warningsSent: "{{count}} avertissements envoyés",
        accountsDeleted: "{{count}} comptes supprimés",
        cleanupError: "Erreur lors de la purge des inactifs",
        missingSecrets: "Secrets manquants: {{missing}}",
        configCheckError: "Erreur lors de la vérification de config",
        usersRecovered: "{{count}} utilisateur(s) récupéré(s)",
        confirmDeletePrompt: "Êtes-vous sûr de vouloir supprimer définitivement l'utilisateur {{name}} ? Cette action est irréversible.",
        proProfile: "Profil Pro",
        trialStatus: "Statut essai",
      }
    },
    pwaPrompt: {
      description: "Activez les notifications pour recevoir des alertes importantes sur vos flashcards et rappels d'étude.",
      privacyNote: "Sécurisé et respectueux de votre vie privée",
      enable: "Activer",
      enabling: "Activation...",
      later: "Plus tard",
    },
    emptyStates: {
      conversations: { title: 'Aucune conversation', description: 'Commencez une nouvelle conversation avec l\'IA médicale pour obtenir de l\'aide.', actionLabel: 'Nouvelle conversation' },
      flashcards: { title: 'Aucune flashcard', description: 'Créez vos premières flashcards pour commencer à réviser efficacement.', actionLabel: 'Créer des flashcards' },
      forum: { title: 'Aucune discussion', description: 'Soyez le premier à lancer une discussion dans cette catégorie.', actionLabel: 'Créer un post' },
      patients: { title: 'Aucun patient', description: 'Aucun patient n\'est actuellement enregistré dans le système.', actionLabel: 'Ajouter un patient' },
      settings: { title: 'Configuration requise', description: 'Configurez vos préférences pour personnaliser votre expérience.', actionLabel: 'Configurer' },
      generic: { title: 'Aucun élément', description: 'Il n\'y a rien à afficher pour le moment.', actionLabel: 'Actualiser' }
    },
    seo: {
      home: { title: 'Sclépios IA — Assistant médical IA', desc: 'Chat médical IA, 67+ calculateurs de scores, flashcards, quiz et cas cliniques. Essai gratuit 7 jours.' },
      dashboard: { title: 'Tableau de bord — Sclépios IA', desc: 'Votre tableau de bord: activités, révisions, abonnements.' },
      auth: { title: 'Connexion / Inscription — Sclépios IA', desc: 'Accédez à votre espace sécurisé Sclépios IA.' },
      chat: { title: 'Chat médical IA — Sclépios IA', desc: 'Posez vos questions médicales à l\'IA. Analyses, diagnostics, formation continue.' },
      study: { title: 'Espace d\'étude — Sclépios IA', desc: 'Ressources et entraînements pour progresser en médecine.' },
      community: { title: 'Communauté médicale — Sclépios IA', desc: 'Partagez et échangez avec la communauté Sclépios.' },
      flashcards: { title: 'Flashcards médicales — Sclépios IA', desc: 'Révisez efficacement avec des flashcards générées par IA.' },
      revisionSheets: { title: 'Fiches de révision — Sclépios IA', desc: 'Fiches synthétiques pour réviser les notions essentielles.' },
      calculator: { title: 'Calculateur médical — Sclépios IA', desc: '67+ scores cliniques avec calcul et interprétation instantanés.' },
      checklists: { title: 'Checklists cliniques — Sclépios IA', desc: 'Procédures et checklists pour sécuriser la pratique.' },
      guidelines: { title: 'Guidelines médicales — Sclépios IA', desc: 'Recommandations et bonnes pratiques à jour.' },
      quiz: { title: 'Quiz médical — Sclépios IA', desc: 'Testez vos connaissances avec des quiz IA.' },
      dailyQuiz: { title: 'Quiz du jour — Sclépios IA', desc: 'Un quiz quotidien pour entretenir vos connaissances.' },
      scores: { title: 'Scores et performances — Sclépios IA', desc: 'Suivez vos progrès et objectifs d\'apprentissage.' },
      medications: { title: 'Médicaments & RCP — Sclépios IA', desc: 'Recherche et analyse des RCP par IA.' },
      coding: { title: 'Coding & prompts — Sclépios IA', desc: 'Atelier de prompts et outils de code assisté.' },
      rss: { title: 'Veille scientifique (RSS) — Sclépios IA', desc: 'Suivez l\'actualité médicale et scientifique.' },
      settings: { title: 'Paramètres & abonnement — Sclépios IA', desc: 'Profil, sécurité, notifications et facturation.' },
      notFound: { title: 'Page introuvable — Sclépios IA', desc: 'La page demandée n\'existe pas ou a été déplacée.' },
      calculateurs: { title: '67+ Calculateurs médicaux gratuits — Sclépios IA', desc: 'Glasgow, SOFA, qSOFA, APACHE II, Wells, CHA2DS2-VASc. Calcul instantané avec interprétation.' },
      calculateur: { title: 'Calculateur médical — Sclépios IA', desc: 'Score médical gratuit avec calcul instantané et interprétation clinique.' },
      blog: { title: 'Blog médical — Cas cliniques commentés | Sclépios IA', desc: 'Cas cliniques commentés par l\'Urgentiste Masqué. Formation médicale continue.' },
      blogPost: { title: 'Cas clinique commenté — Sclépios IA', desc: 'Analyse détaillée avec prise en charge et points clés.' },
      features: { title: 'Fonctionnalités — Sclépios IA', desc: 'Découvrez toutes les fonctionnalités de l\'assistant médical IA : chat, calculateurs, flashcards, quiz et cas cliniques.' },
      articles: { title: 'Articles médicaux — Sclépios IA', desc: 'Articles médicaux rédigés par des professionnels de santé.' },
      articlePost: { title: 'Article médical — Sclépios IA', desc: 'Article médical détaillé avec références et points clés.' },
      aboutDoctor: { title: 'À propos — Dr Galindo | Sclépios IA', desc: 'Découvrez le créateur de Sclépios IA, médecin urgentiste et développeur.' },
      cgu: { title: 'Conditions Générales d\'Utilisation — Sclépios IA', desc: 'CGU de la plateforme Sclépios IA.' },
      privacy: { title: 'Politique de Confidentialité — Sclépios IA', desc: 'Protection des données personnelles. Conforme RGPD.' },
      mentionsLegales: { title: 'Mentions Légales — Sclépios IA', desc: 'Informations légales de la plateforme Sclépios IA.' },
      pricing: { title: 'Tarifs — Sclépios IA', desc: 'Abonnements Essential, Pro et Team. Essai gratuit 7 jours sans carte bancaire.' },
      admin: { title: 'Administration — Sclépios IA', desc: 'Outils d\'administration Sclépios IA.' },
      adminDashboard: { title: 'Admin — Tableau de bord', desc: 'Vue d\'ensemble des métriques et contrôles d\'administration.' },
      adminUsage: { title: 'Admin — Statistiques d\'usage', desc: 'Coûts, requêtes et modèles utilisés.' },
      adminPrompts: { title: 'Admin — Prompts IA', desc: 'Gestion et révision des prompts utilisés côté serveur.' },
      adminNotifications: { title: 'Admin — Notifications', desc: 'Campagnes et paramètres de notifications.' },
      adminUsers: { title: 'Admin — Utilisateurs', desc: 'Gestion des utilisateurs et abonnements.' },
      adminLogs: { title: 'Admin — Logs système', desc: 'Événements de sécurité et d\'activité.' },
      adminPushDebug: { title: 'Admin — Debug Push', desc: 'Diagnostics des notifications push.' },
      adminSamples: { title: 'Admin — Envoi d\'échantillons', desc: 'Envoi d\'exemples d\'emails/notifications.' },
      fallback: { title: 'Sclépios IA', desc: 'Assistant IA médical pour professionnels de santé.' }
    },
    medication: {
      noName: 'Médicament sans nom',
      add: 'Ajouter',
      noMedication: 'Aucun médicament ajouté',
      clickToEdit: 'Cliquez pour modifier',
      name: 'Nom du médicament',
      dosage: 'Dosage',
      unit: 'Unité',
      frequency: 'Fréquence',
      route: 'Voie'
    },
    moderation: {
      moderate: 'Modérer',
      actions: 'Actions de modération',
      hideContent: 'Masquer le contenu',
      deletePermanently: 'Supprimer définitivement',
      banUser: 'Bannir l\'utilisateur',
      banTitle: 'Bannir l\'utilisateur',
      deleteTitle: 'Supprimer le contenu',
      banDesc: 'Cette action bannira l\'utilisateur de la communauté. Indiquez la raison du bannissement.',
      deleteDesc: 'Cette action supprimera définitivement le contenu. Cette action est irréversible.',
      banReason: 'Raison du bannissement',
      selectReason: 'Sélectionnez une raison',
      spam: 'Spam répété',
      harassment: 'Harcèlement',
      inappropriate: 'Contenu inapproprié',
      misinformation: 'Désinformation médicale grave',
      privacy: 'Violation grave de confidentialité',
      other: 'Autre',
      banDuration: 'Durée du bannissement',
      selectDuration: 'Sélectionnez la durée',
      days7: '7 jours',
      days30: '30 jours',
      days90: '90 jours',
      permanent: 'Permanent',
      banning: 'Bannissement...',
      ban: 'Bannir',
      warning: 'Attention : Action irréversible',
      warningDesc: 'Le contenu sera définitivement supprimé et ne pourra pas être récupéré.',
      deleting: 'Suppression...',
      deleteConfirm: 'Supprimer définitivement'
    },
    rss: {
      statsTitle: 'Statistiques RSS',
      subscribedFeeds: 'Flux abonnés',
      unread: 'Non lues',
      favorites: 'Favoris',
      readThisWeek: 'Lus cette semaine',
      customFeeds: 'Flux personnalisés',
      globalActivity: 'Activité globale',
      veryActive: 'Très actif',
      active: 'Actif',
      lowActive: 'Peu actif'
    },
    premium: {
      upgradeTo: 'Passez à Premium',
      unlockAll: 'Déverrouillez toutes les fonctionnalités : cas cliniques, révision express, statistiques avancées...',
      seeOffers: 'Voir les offres'
    },
    hallOfFame: {
      youAre: 'Vous êtes #{{rank}}',
      congrats: '🎉 Félicitations ! Vous êtes sur le podium (#{{rank}})',
      seeCategories: 'Voir les catégories d\'excellence',
      you: '(vous)'
    },
    consultations: {
      history: 'Antériorités',
      noConsultation: 'Aucune consultation enregistrée pour ce patient',
      createFirst: 'Créer la première consultation',
      noStructuredElements: 'Aucun élément structuré dans la dernière consultation',
      lastConsultation: 'Dernière consultation',
      newConsultation: 'Nouvelle consultation',
      antecedents: 'Antécédents',
      medical: 'Médicaux',
      surgical: 'Chirurgicaux',
      treatments: 'Traitements habituels',
      lifestyle: 'Mode de vie',
      autoFillNote: 'Ces éléments seront automatiquement préremplis dans les nouvelles consultations',
      medication: 'Médicament',
      lifestyleElement: 'Élément mode de vie'
    },
    studyStats: {
      noReviewPeriod: 'Aucune révision sur cette période',
      startReviewing: 'Commencez à réviser pour voir vos statistiques',
      noCardsCreated: 'Aucune carte créée',
      createFirstCards: 'Créez vos premières flashcards pour suivre votre progression',
      totalCards: 'cartes',
      days7: '7 jours',
      days30: '30 jours',
      days90: '90 jours'
    },
    upgrade: {
      quizTitle: 'Vous êtes sur une lancée ! 🎯',
      quizDesc: 'Vous avez complété 5 quiz. Débloquez les cas cliniques interactifs pour progresser encore plus vite.',
      quizFeature: 'Cas Cliniques Pro',
      flashcardTitle: 'Bravo pour votre assiduité ! 📚',
      flashcardDesc: '{{count}} flashcards créées ! Passez à Premium pour accéder à Révision Express et optimiser votre temps.',
      flashcardFeature: 'Révision Express',
      streakTitle: '7 jours de streak ! 🔥',
      streakDesc: 'Maintenez votre progression avec les statistiques avancées et suivez votre évolution en détail.',
      streakFeature: 'Stats Avancées',
      conversationTitle: 'Limite de conversations atteinte 💬',
      conversationDesc: 'Vous avez utilisé 4/5 conversations ce mois. Passez à Premium pour des conversations illimitées.',
      conversationFeature: 'Conversations illimitées',
      unlock: 'Débloquer'
    }
  },
  en: {
    loading: 'Loading...',
    loadingPage: 'Loading page...',
    error: 'Error',
    cached: 'Cached',
    searchCount: '{{count}} searches',
    back: 'Back',
    all: 'All',
    save: 'Save',
    select: 'Select',
    delete: 'Delete',
    xpEarned: '{{xp}} XP earned',
    connectionRestored: "Connection restored",
    offlineModeActive: "Offline mode active",
    limitedFunctionsAvailable: "Limited functions available",
    actionSavedOffline: "Action saved offline",
    offlineDataSynced: "{{count}} offline action(s) synchronized",
    syncFailed: "Synchronization failed",
    syncingOfflineData: "Synchronizing offline data",
    offlineDataPending: "Offline data pending synchronization",
    syncNow: "Sync now",
    expandAll: "Expand all",
    collapseAll: "Collapse all",
    edit: "Edit",
    search: "Search",
    searchInApp: "Search in the application",
    preview: "Preview",
    saved: "Saved",
    saving: "Saving...",
    savedOffline: "Saved offline",
    lastSaved: "Last saved: {{time}}",
    backToDashboard: "Back to dashboard",
    home: "Home",
    menu: "Menu",
    notificationsLabel: "Notifications",
    nav: {
      dashboard: 'Dashboard',
      checklists: 'Checklists'
    },
    settingsMenu: {
      settings: 'Settings',
      administration: 'Administration',
      themeLight: 'Light theme',
      themeDark: 'Dark theme',
      themeSystem: 'System theme',
      logout: 'Log out',
    },
    sidebar: {
      dashboard: 'Dashboard',
      chatAI: 'AI Chat',
      flashcards: 'Flashcards',
      revisionSheets: 'Revision Sheets',
      dailyQuiz: 'Daily Quiz',
      study: 'Study',
      courses: 'Courses',
      clinicalCases: 'Clinical Cases',
      challenges: 'Challenges',
      revisionExpress: 'Express Review',
      calculators: 'Calculators',
      checklists: 'Checklists',
      medications: 'Medications',
      coding: 'Coding',
      guidelines: 'Guidelines',
      forum: 'Forum',
      scores: 'Scores',
      achievements: 'Achievements',
      hallOfFame: 'Hall of Fame',
      settings: 'Settings',
      groupMain: 'Main',
      groupLearning: 'Learning',
      groupTools: 'Clinical Tools',
      groupCommunity: 'Community',
    },
    requiredName: {
      title: '👋 What is your name?',
      description: 'Your name will be displayed in the Hall of Fame and the community. This information is required to continue.',
      placeholder: 'Dr. First Last',
      minChars: 'Minimum 3 characters',
      continue: 'Continue'
    },
    units: {
      minutes: 'min',
      days: 'd',
      cards: 'cards'
    },
    preparingOfflineContent: "Preparing offline content",
    offlineContentReady: "Offline content ready",
    downloadOfflineContent: "Download offline content",
    downloadingEssentialContent: "Downloading essential content...",
    appReadyOffline: "App ready for offline use",
    enableOfflineAccess: "Enable offline access",
    connectToDownload: "Connect to download",
    downloadComplete: "Download complete",
    essentialContentCached: "Essential content cached",
    downloadFailed: "Download failed",
    offlineContent: "Offline content",
    cachedItems: "Cached items",
    storageUsed: "Storage used",
    offlineStatus: "Offline status",
    ready: "Ready",
    notReady: "Not ready",
    cachedContent: "Cached content",
    manageOfflineContent: "Manage offline content",
    downloadEssentials: "Download essentials",
    cleanupOld: "Cleanup old",
    clearAll: "Clear all",
    offlineDownloadUnavailable: "Download unavailable offline",
    cacheCleared: "Cache cleared",
    offlineContentRemoved: "Offline content removed",
    clearFailed: "Clear failed",
    cleanupComplete: "Cleanup complete",
    oldContentRemoved: "Old content removed",
    cleanupFailed: "Cleanup failed",
    tryAgainLater: "Try again later",
    cancel: "Cancel",
    closeDialog: "Close dialog",
    close: "Close",
    camera: {
      capture: "Capture",
      takePhoto: "Take a photo",
      photoCapture: "Photo capture"
    },
    copied: "Copied!",
    copyError: "Unable to copy",
    shareButton: 'Share',
    shared: 'Shared ✓',
    copy: 'Copy',
    later: 'Later',
    pricing: 'Pricing',
    success: 'Success',
    shareExploit: 'Share your achievement with your colleagues!',
    pwa: {
      howToInstall: "How to install the app:",
      iosInstall: 'Install on Safari iOS',
      iosTroubleshoot: "If buttons don't respond, try these solutions:",
      tapShare: 'Tap the Share button',
      bottomSafari: 'At the bottom of the screen in Safari',
      addHomeScreen: 'Scroll down and select "Add to Home Screen"',
      scrollDown: 'Scroll down in the options list',
      tapAdd: 'Tap "Add" to confirm',
      stillNotWorking: "If it still doesn't work:",
      refreshPage: 'Refresh the page (pull down)',
      restartSafari: 'Restart Safari completely',
      checkSafari: "Make sure you're on Safari (not Chrome iOS)",
      tryPrivate: 'Try in private browsing mode',
      iconWillAppear: 'The Sclepios icon will appear on your home screen!',
      tapMenu: 'Tap the menu (3 dots)',
      selectInstall: 'Select "Install app" or "Add to Home Screen"',
      confirmInstall: 'Confirm the installation',
      quickAccess: 'Quick access from your home screen!',
      iosInstructionAlert: 'To install the app: Tap the Share button then "Add to Home Screen"',
      androidInstructionAlert: 'To install the app: Open the browser menu then "Add to Home Screen"',
      unsupported: "Your browser does not support installing web applications",
      installSclepios: 'Install Sclepios',
      installSclepiosAI: 'Install Sclepios AI',
      quickAccessNotifications: 'Quick access and notifications',
      install: 'Install',
      installNow: 'Install now',
      installDesktopDesc: "Install the app for quick access and notifications.",
      dontShowAgain: "Don't show again"
    },
    followUrgentiste: 'Follow the Masked ER Doctor:',
    availableCases: 'Available clinical cases',
    exploreCases: 'Explore authentic clinical cases and their detailed management',
    searchCases: 'Search by keyword, tag or pathology...',
    casesFound: '{{count}} case(s) found for "{{term}}"',
    unexpectedError: "An error occurred",
    saveError: "Error saving",
    nameSaved: "Name saved!",
    registrationError: "Error registering",
    enterName: "Please enter your name",
    invalidEmail: "Please enter a valid email address",
    enterDifferentEmail: "Please enter a different email address",
    emailConfirmSent: "A confirmation email has been sent to your new address. Click the link to confirm the change.",
    emailChangeError: "Error changing email",
    referralCopied: "Referral link copied!",
    challengeJoined: "You joined the challenge!",
    challengeJoinError: "Unable to join the challenge",
    selectReason: "Please select a reason",
    userBanned: "User banned successfully",
    banError: "Error banning user",
    postDeleted: "Post deleted",
    replyDeleted: "Reply deleted",
    deleteError: "Error deleting",
    contentHidden: "Content hidden",
    hideError: "Error hiding content",
    promptCreated: "Prompt created successfully",
    promptCreateError: "Error creating prompt",
    promptUpdated: "Prompt updated successfully",
    promptUpdateError: "Error updating prompt",
    promptArchived: "Prompt archived",
    promptArchiveError: "Error archiving",
    promptDeleteError: "Error deleting",
    metricsLoadError: "Error loading metrics",
    notifications: {
      streakDanger: "Your streak is in danger! 🔥",
      streakDangerDesc: "You haven't studied in 2 days. Keep your streak going!",
      review: "Review",
      newGuideline: "New guideline available 📚",
      guidelineDesc: "{{count}} new recommendation(s) in {{specialty}}",
      see: "View",
      top5: "You're in the top 5! 🏆",
      top5Desc: "Position #{{position}} on the leaderboard this week",
      newBadge: "New badge unlocked! 🎉",
      referralSuccess: "A colleague joined Sclépios thanks to you! 🎉",
      referralDesc: "Thanks for the referral! Keep sharing."
    },
    patients: {
      loadError: "Error loading patients",
      loadOneError: "Error loading patient",
    saveError: "Error saving",
    usageLoadError: "Error loading your usage",
    backgroundTasks: {
      launchError: "Unable to start generation",
      generating: "generating...",
      navigateFreely: "You can navigate freely",
      aiGenerating: "AI generations in progress",
      flashcards: "Flashcards",
      revisionSheet: "Revision sheet",
      qcm: "MCQ",
      clinicalCase: "Clinical case",
      processing: "processing",
      pending: "pending",
    },
    onboarding: {
      completeProfile: "Please complete your profile to continue",
      welcomeSuccess: "Welcome! Your profile has been set up successfully.",
      saveError: "Error saving profile",
      configTitle: "Profile setup",
      configDesc: "Customize your Sclepios experience",
      previous: "Previous",
      skip: "Skip",
      profileRequired: "Profile required",
      next: "Next",
      finalizing: "Finalizing...",
      finish: "Finish",
      readyToStart: "Ready to start!",
      readyDesc: "You're now ready to use all Sclepios features.",
      medicalAI: "Medical AI",
      adaptiveQuiz: "Adaptive quizzes",
      steps: {
        profile: { title: "Professional profile", desc: "Help us personalize your experience", fullName: "Full name", fullNamePlaceholder: "Your full name", userType: "User type", selectProfession: "Select your profession" },
        practice: { title: "Practice mode", desc: "Describe your work environment", mode: "Practice mode", selectMode: "Select your practice mode", specialty: "Specialty", selectSpecialty: "Select your specialty" },
        service: { title: "Department", desc: "Which department do you work in?", label: "Department", selectService: "Select your department" },
        preferences: { title: "Preferences", desc: "Customize your experience", notifications: "Notifications", notificationsDesc: "Receive notifications for flashcards and reminders", tips: "Tips & tricks", tipsDesc: "Receive tips to optimize your usage", newsletterDesc: "Receive our monthly newsletter with updates" }
      },
      welcomeTitle: '🎉 Welcome to Sclépios!',
      welcomeDesc: 'Your personal medical AI assistant',
      firstStepBadge: 'First Step',
      chatTitle: '💬 Ask your first question',
      chatDesc: 'Try the medical AI now',
      creatorBadge: 'Creator',
      startIn30s: 'Get started in 30 seconds',
      tellUsWho: 'Tell us who you are',
      yourName: 'Your name *',
      specialtyOptional: 'Specialty (optional)',
      specialtyPlaceholder: 'Emergency, General practice...',
      rewards: 'Rewards',
      congrats: 'Congratulations {{name}}! 🎉',
      badgeEarned: 'You unlocked the "First Step" badge and earned 50 XP!',
      welcomeToast: '🎉 Welcome! You earned 50 XP!',
      badgeUnlocked: '"First Step" badge unlocked',
      readyForQuestion: 'Ready for your first question?',
      askAnything: 'Ask any medical question to the AI',
      example1: 'What are the warning signs of a heart attack?',
      example2: 'Protocol for respiratory distress management',
      example3: 'Create flashcards on cardiology',
      tip: '💡 Tip: You will earn 100 XP and the "Creator" badge after your first conversation!',
      continue: 'Continue',
      askFirstQuestion: 'Ask my first question'
    },
      updated: "Patient updated",
      created: "Patient created",
      deleted: "Patient deleted",
      deleteError: "Error deleting"
    },
    photo: {
      unsupportedFormat: "Unsupported image format. Use PNG, JPEG, WEBP or GIF.",
      tooLarge: "Image too large. Maximum size: 50MB.",
      textDetected: "Text detected in the image!",
      imageAdded: "Image added - no text detected",
      processingError: "Error processing image",
      selectImage: "Please select an image file",
      cameraError: "Error processing photo",
      takePhoto: "Take a photo",
      selectFromGallery: "Select an image"
    },
    documents: {
      unsupportedType: "Unsupported file type. Use JPG, PNG, WebP, PDF, TXT or DOCX.",
      tooLarge: "File too large. Maximum 10MB per file.",
      maxFiles: "Maximum 5 files allowed",
      selectAtLeast: "Please select at least one document",
      ocrNoText: "OCR completed but no text detected in images",
      noTextDetected: "No text detected in documents. Check quality and try \"Force PDF OCR\" if needed.",
      photoCaptured: "Photo captured successfully!",
      readError: "Error reading file {{name}}",
      ocrSuccess: "OCR complete: text extracted from {{count}} image(s)",
      extractionComplete: "Extraction complete. {{count}} file(s) processed.",
      importTitle: "Document Import",
      importDesc: "Import your documents to automatically extract text",
      captureTitle: "Document Capture",
      captureDesc: "Take a photo or select medical documents (images, PDF, TXT, DOCX)",
      takePhoto: "Take a photo",
      selectFiles: "Select files",
      extracting: "Extracting text...",
      extractText: "Extract text ({{count}} file{{plural}})",
      formatsSupported: "Supported formats: JPG, PNG, WebP, PDF, TXT, DOCX (max 10MB per file)",
      maxFilesInfo: "Maximum 5 files per batch",
      pdfInfo: "PDF: automatic text detection • Images: high quality OCR • TXT/DOCX: direct extraction",
      pdfDetected: "Readable PDF detected: {{count}} characters extracted",
      pdfProcessError: "Unable to process PDF file",
      processingPdf: "Processing PDF: {{name}}...",
      pdfToOcr: "PDF converted to images for OCR: {{count}} page(s)",
      extractingImages: "Extracting text from {{count}} image(s)...",
      ocrError: "OCR error: {{message}}",
      forcePdfOcr: "Scanned or poor quality PDFs? Check \"Force PDF OCR\""
    },
    profile: {
      streakDays: "Day streak",
      badges: "Badges",
      shareProfile: "Share this profile",
      joinSclepios: "Join Sclépios AI",
      joinDesc: "The intelligent medical assistant for healthcare professionals",
      createFreeAccount: "Create a free account",
      signoutError: "Error signing out"
    },
    admin: {
      costAlerts: {
        title: "Cost Alerts",
        description: "Real-time cost and ROI monitoring",
        testAlert: "Test alert sent",
        testAlertError: "Error sending test alert",
        monthlyRevenue: "Monthly Revenue",
        aiCosts: "AI Costs",
        margin: "Margin",
        noAlerts: "No active alerts",
        allNormal: "All indicators are within normal limits",
        refresh: "Refresh"
      },
      quickActions: {
        createTemplate: "Quick template creation",
        templateName: "Template name",
        templateType: "Type",
        templateSubject: "Subject",
        templateContent: "Content",
        templatePlaceholder: "Template content...",
        createBtn: "Create template",
        expressCampaign: "Express campaign",
        targetAudience: "Target audience",
        allUsers: "All users",
        doctors: "Doctors",
        residents: "Residents",
        nurses: "Nurses",
        emailSubject: "Subject",
        emailMessage: "Message",
        emailPlaceholder: "Message content...",
        sendNow: "Send now",
        systemActions: "System actions",
        clearCache: "Clear cache",
        securityAudit: "Security audit",
        refresh: "Refresh",
        success: "Success",
        templateCreated: "Template created successfully",
        templateCreateError: "Unable to create template",
        fillFields: "Please fill in the subject and content",
        campaignSent: "Campaign sent! {{count}} recipients",
        campaignSendError: "Unable to send campaign",
        cacheCleared: "Cache cleared successfully",
        cacheClearError: "Unable to clear cache",
        auditComplete: "Audit complete - Check logs for details",
        auditError: "Unable to run security audit"
      },
      pushTest: {
        title: "Push Notification Test",
        description: "Send test push notifications",
        notifTitle: "Title",
        notifMessage: "Message",
        targetUser: "Target User ID (optional)",
        targetPlaceholder: "Leave empty for all users",
        sending: "Sending...",
        sendNotif: "Send notification",
        titlePlaceholder: "Notification title",
        messagePlaceholder: "Notification body"
      },
      usageStats: {
        period: "Period",
        last24h: "Last 24h",
        last7days: "Last 7 days",
        last30days: "Last 30 days",
        last90days: "Last 90 days",
        allTime: "All time",
        function: "Function",
        allFunctions: "All functions",
        loadingStats: "Loading statistics..."
      },
      sendSamples: {
        pageTitle: "Admin · Warning Emails",
        title: "Warning Emails",
        description: "This page triggers sending 3 sample emails (trial reminder, post-trial warning, winback) to {{to}}.",
        sent: "Sample emails sent to {{to}}",
        error: "Error sending emails",
        status: "Status"
      }
    },
    paywall: {
      conversationCount: { title: "You're making great progress! 🚀", description: "You've already had {{count}} conversations with Sclepios AI. Go Premium to continue without limits." },
      longExchange: { title: "Deep discussion 💡", description: "You're in the middle of clinical reasoning! With Premium, continue your exchanges without interruption." },
      featureDiscovery: { title: "Premium Feature 👑", description: "Unlock the full potential of Sclepios with Premium.", descriptionWithSpecialty: "As a {{specialty}} professional, unlock the full potential of Sclepios." },
      streakRisk: { title: "Protect your streak! 🔥", description: "Your streak is at risk. With Premium, get smart reminders to never lose your progress." },
      features: {
        unlimitedConversations: "Unlimited conversations",
        clinicalCases: "Interactive clinical cases",
        advancedStats: "Advanced statistics",
        unlimitedExchanges: "Unlimited exchanges",
        detailedAnswers: "More detailed answers",
        priorityAccess: "Priority access",
        allFeatures: "All features",
        advancedAI: "Advanced medical AI",
        optimizedProgress: "Optimized progress",
        personalizedReminders: "Personalized reminders",
        detailedStats: "Detailed statistics",
        exclusiveBadges: "Exclusive badges"
      },
      viewPremium: "View Premium offers",
      continueFree: "Continue for free",
      trialInfo: "7-day free trial • Cancel anytime"
    },
    patientEdit: {
      updated: "Patient information updated",
      updateError: "Error updating information",
      personalInfo: "Personal information",
      years: "years",
      sex: "Sex",
      editTitle: "Edit patient information",
      emergencyContact: "Emergency contact",
      name: "Name",
      relationship: "Relationship",
      kinship: "Kinship",
      kinshipPlaceholder: "Spouse, Child, Parent...",
      lastName: "Last name",
      firstName: "First name",
      selectOption: "Select",
      male: "Male",
      female: "Female",
      other: "Other",
      unspecified: "Unspecified"
    },
    photoCapture: {
      cameraError: "Error accessing camera",
      unsupportedFormat: "Unsupported image format. Please use JPG, PNG, GIF, WebP, HEIC, HEIF or AVIF.",
      tooLarge: "Image too large. Maximum size: 10MB",
      invalidFormat: "Invalid data format",
      extractSuccess: "Text extracted successfully ({{count}} characters)",
      noTextDetected: "No text detected in the image. Make sure the image contains readable text.",
      extractError: "Error extracting text",
      takePhoto: "Take a photo",
      selectImage: "Select an image"
    },
    structuredList: {
      newItem: "New item",
      addItem: "Add an item"
    },
    share: {
      copiedToClipboard: "Copied to clipboard!",
      shareError: "Unable to share",
      quizTitle: "Daily Quiz — Sclépios AI",
      quizText: "🩺 I scored {{percentage}}% ({{score}}/{{total}}) on the Daily Quiz on Sclépios AI! Test your medical knowledge 👇",
      streakTitle: "Learning Streak — Sclépios AI",
      streakText: "{{emoji}} {{days}} day streak on Sclépios AI! Medical learning, one day at a time 💪",
      badgeTitle: "Badge Unlocked — Sclépios AI",
      badgeText: "🏅 I unlocked the \"{{name}}\" badge on Sclépios AI! Join the medical community 🩺",
      revisionTitle: "Express Review — Sclépios AI",
      revisionText: "⚡ Express Review completed: {{correct}}/{{total}} ({{accuracy}}%) on Sclépios AI! Express mode for efficient revision 🧠",
      clinicalCaseTitle: "Clinical Case — Sclépios AI",
      clinicalCaseText: "🏥 I solved the clinical case \"{{title}}\" with {{percentage}}% correct answers ({{score}}/{{total}}) on Sclépios AI! Try it too 👇",
      revisionSheetTitle: "Revision Sheet — Sclépios AI",
      revisionSheetText: "📋 I generated a revision sheet \"{{title}}\" in {{specialty}} on Sclépios AI! AI-powered medical learning 🩺",
      deckText: "📚 Check out my deck \"{{name}}\" ({{count}} cards) on Sclépios AI! Revise efficiently with flashcards 🧠"
    },
    adminPages: {
      toasts: {
        usersLoadError: "Error loading users",
        unauthorized: "Unauthorized action",
        trialExtended: "Trial extended by 7 days",
        trialExtendError: "Error extending trial",
        userDeleted: "User deleted successfully",
        userDeleteError: "Error deleting user",
        secretsOk: "✅ All secrets are configured",
        auditError: "Error running audit",
        noMissingUsers: "No missing users detected",
        recoverError: "Error recovering users",
        stripeSynced: "Stripe data synced",
        stripeSyncError: "Error syncing Stripe",
        featureInDev: "Feature in development"
      },
      users: {
        title: "User Management",
        subtitle: "Manage user accounts, roles and permissions",
        accessDenied: "Unauthorized access",
        restricted: "Restricted access",
        noPermission: "You don't have the required permissions to access this page.",
        showDashboard: "Show",
        hideDashboard: "Hide",
        dashboard: "Dashboard",
        refresh: "Refresh",
        verifyConfig: "Verify config",
        warnInactive: "Warn inactive",
        deleteInactive: "Delete inactive",
        userList: "User list",
        manageRolesDesc: "Manage user roles and permissions",
        loadingUsers: "Loading users...",
        noUsersFound: "No users found",
        noName: "No name",
        user: "User",
        role: "Role",
        profile: "Profile",
        subscription: "Subscription",
        status: "Status",
        registered: "Registered",
        actions: "Actions",
        expiresOn: "Expires on",
        expired: "Expired",
        notDefined: "Not defined",
        revoke: "Revoke",
        activate: "Activate",
        extend: "Extend",
        deleteUser: "Delete",
        deleteConfirmTitle: "Delete user",
        deleteConfirmDesc: "Are you sure you want to permanently delete this user? This action is irreversible.",
        cancel: "Cancel",
        auditTitle: "User account audit",
        auditRefresh: "Refresh",
        missingAccounts: "{{count}} missing account(s) detected",
        noMissing: "No missing accounts detected",
        auditPending: "Audit in progress or unavailable...",
        missingDesc: "Some users don't appear in the listing because they don't have a healthcare_providers entry.",
        recoverAction: "Click \"Recover\" to restore them automatically.",
        recoverBtn: "Recover missing users",
        allSynced: "✅ All user accounts are properly synchronized.",
        clickRefresh: "ℹ️ Click \"Refresh\" to run the account audit.",
        promoCodes: "Promotional codes",
        activePromoCodes: "Active promo codes",
        promoDesc: "Manage discount codes for your users",
        createCode: "Create code",
        noPromoCodes: "No promotional codes created",
        promoComingSoon: "This feature will be available soon",
        premiumFree: "Free Premium",
        freeTrial: "Free trial",
        trialExpired: "Trial expired",
        free: "Free",
        warningsSent: "{{count}} warnings sent",
        accountsDeleted: "{{count}} accounts deleted",
        cleanupError: "Error cleaning up inactive users",
        missingSecrets: "Missing secrets: {{missing}}",
        configCheckError: "Error verifying config",
        usersRecovered: "{{count}} user(s) recovered",
        confirmDeletePrompt: "Are you sure you want to permanently delete the user {{name}}? This action is irreversible.",
        proProfile: "Pro Profile",
        trialStatus: "Trial status",
      }
    },
    pwaPrompt: {
      description: "Enable notifications to receive important alerts about your flashcards and study reminders.",
      privacyNote: "Secure and privacy-friendly",
      enable: "Enable",
      enabling: "Enabling...",
      later: "Later",
    },
    emptyStates: {
      conversations: { title: 'No conversations', description: 'Start a new conversation with the medical AI.', actionLabel: 'New conversation' },
      flashcards: { title: 'No flashcards', description: 'Create your first flashcards to start reviewing efficiently.', actionLabel: 'Create flashcards' },
      forum: { title: 'No discussions', description: 'Be the first to start a discussion in this category.', actionLabel: 'Create a post' },
      patients: { title: 'No patients', description: 'No patients are currently registered in the system.', actionLabel: 'Add a patient' },
      settings: { title: 'Configuration required', description: 'Configure your preferences to personalize your experience.', actionLabel: 'Configure' },
      generic: { title: 'No items', description: 'There is nothing to display at the moment.', actionLabel: 'Refresh' }
    },
    seo: {
      home: { title: 'Sclépios AI - Medical Assistant', desc: 'AI medical assistant: chat, training, revision, community.' },
      dashboard: { title: 'Dashboard - Sclépios AI', desc: 'Your dashboard: activities, revisions, subscriptions.' },
      auth: { title: 'Login / Register - Sclépios AI', desc: 'Access your secure Sclépios AI space.' },
      chat: { title: 'Medical Chat - Sclépios AI', desc: 'Chat with the medical AI: analyses, diagnostics, training.' },
      study: { title: 'Study Space - Sclépios AI', desc: 'Resources and training to advance in medicine.' },
      community: { title: 'Medical Community - Sclépios AI', desc: 'Share and exchange with the Sclépios community.' },
      flashcards: { title: 'Medical Flashcards - Sclépios AI', desc: 'Review efficiently with AI-generated flashcards.' },
      revisionSheets: { title: 'Revision Sheets - Sclépios AI', desc: 'Summary sheets to review essential concepts.' },
      calculator: { title: 'Medical Calculator - Sclépios AI', desc: 'Reliable clinical calculation and scoring tools.' },
      checklists: { title: 'Clinical Checklists - Sclépios AI', desc: 'Procedures and checklists for safe practice.' },
      guidelines: { title: 'Medical Guidelines - Sclépios AI', desc: 'Up-to-date recommendations and best practices.' },
      quiz: { title: 'Medical Quiz - Sclépios AI', desc: 'Test your knowledge with AI quizzes.' },
      dailyQuiz: { title: 'Daily Quiz - Sclépios AI', desc: 'A daily quiz to maintain your knowledge.' },
      scores: { title: 'Scores & Performance - Sclépios AI', desc: 'Track your progress and learning goals.' },
      medications: { title: 'Medications & SPC - Sclépios AI', desc: 'Search and AI-powered SPC analysis.' },
      coding: { title: 'Coding & Prompts - Sclépios AI', desc: 'Prompt workshop and assisted coding tools.' },
      rss: { title: 'Scientific Watch (RSS) - Sclépios AI', desc: 'Follow curated medical and scientific news.' },
      settings: { title: 'Settings & Subscription - Sclépios AI', desc: 'Profile, security, notifications and billing.' },
      notFound: { title: 'Page Not Found - Sclépios AI', desc: 'The requested page does not exist or has been moved.' },
      admin: { title: 'Administration - Sclépios AI', desc: 'Sclépios AI administration tools.' },
      adminDashboard: { title: 'Admin - Dashboard', desc: 'Overview of metrics and administration controls.' },
      adminUsage: { title: 'Admin - Usage Statistics', desc: 'Costs, queries and models used.' },
      adminPrompts: { title: 'Admin - AI Prompts', desc: 'Management and review of server-side prompts.' },
      adminNotifications: { title: 'Admin - Notifications', desc: 'Campaigns and notification settings.' },
      adminUsers: { title: 'Admin - Users', desc: 'User management and subscriptions.' },
      adminLogs: { title: 'Admin - System Logs', desc: 'Security and activity events.' },
      adminPushDebug: { title: 'Admin - Push Debug', desc: 'Push notification diagnostics.' },
      adminSamples: { title: 'Admin - Send Samples', desc: 'Send sample emails/notifications.' },
      features: { title: 'Features — Sclépios AI', desc: 'Discover all features of the AI medical assistant: chat, calculators, flashcards, quizzes and clinical cases.' },
      articles: { title: 'Medical Articles — Sclépios AI', desc: 'Medical articles written by healthcare professionals.' },
      articlePost: { title: 'Medical Article — Sclépios AI', desc: 'Detailed medical article with references and key points.' },
      aboutDoctor: { title: 'About — Dr Galindo | Sclépios AI', desc: 'Meet the creator of Sclépios AI, emergency physician and developer.' },
      fallback: { title: 'Sclépios AI', desc: 'AI medical assistant: chat, revision, community.' }
    },
    medication: {
      noName: 'Unnamed medication',
      add: 'Add',
      noMedication: 'No medication added',
      clickToEdit: 'Click to edit',
      name: 'Medication name',
      dosage: 'Dosage',
      unit: 'Unit',
      frequency: 'Frequency',
      route: 'Route'
    },
    moderation: {
      moderate: 'Moderate',
      actions: 'Moderation actions',
      hideContent: 'Hide content',
      deletePermanently: 'Delete permanently',
      banUser: 'Ban user',
      banTitle: 'Ban user',
      deleteTitle: 'Delete content',
      banDesc: 'This action will ban the user from the community. Indicate the reason for the ban.',
      deleteDesc: 'This action will permanently delete the content. This action is irreversible.',
      banReason: 'Ban reason',
      selectReason: 'Select a reason',
      spam: 'Repeated spam',
      harassment: 'Harassment',
      inappropriate: 'Inappropriate content',
      misinformation: 'Serious medical misinformation',
      privacy: 'Serious privacy violation',
      other: 'Other',
      banDuration: 'Ban duration',
      selectDuration: 'Select duration',
      days7: '7 days',
      days30: '30 days',
      days90: '90 days',
      permanent: 'Permanent',
      banning: 'Banning...',
      ban: 'Ban',
      warning: 'Warning: Irreversible action',
      warningDesc: 'The content will be permanently deleted and cannot be recovered.',
      deleting: 'Deleting...',
      deleteConfirm: 'Delete permanently'
    },
    rss: {
      statsTitle: 'RSS Statistics',
      subscribedFeeds: 'Subscribed feeds',
      unread: 'Unread',
      favorites: 'Favorites',
      readThisWeek: 'Read this week',
      customFeeds: 'Custom feeds',
      globalActivity: 'Global activity',
      veryActive: 'Very active',
      active: 'Active',
      lowActive: 'Low activity'
    },
    premium: {
      upgradeTo: 'Upgrade to Premium',
      unlockAll: 'Unlock all features: clinical cases, express review, advanced statistics...',
      seeOffers: 'See offers'
    },
    hallOfFame: {
      youAre: 'You are #{{rank}}',
      congrats: '🎉 Congratulations! You are on the podium (#{{rank}})',
      seeCategories: 'See excellence categories',
      you: '(you)'
    },
    consultations: {
      history: 'History',
      noConsultation: 'No consultation recorded for this patient',
      createFirst: 'Create first consultation',
      noStructuredElements: 'No structured elements in the last consultation',
      lastConsultation: 'Last consultation',
      newConsultation: 'New consultation',
      antecedents: 'Medical history',
      medical: 'Medical',
      surgical: 'Surgical',
      treatments: 'Regular treatments',
      lifestyle: 'Lifestyle',
      autoFillNote: 'These elements will be automatically pre-filled in new consultations',
      medication: 'Medication',
      lifestyleElement: 'Lifestyle element'
    },
    studyStats: {
      noReviewPeriod: 'No reviews in this period',
      startReviewing: 'Start reviewing to see your statistics',
      noCardsCreated: 'No cards created',
      createFirstCards: 'Create your first flashcards to track your progress',
      totalCards: 'cards',
      days7: '7 days',
      days30: '30 days',
      days90: '90 days'
    },
    upgrade: {
      quizTitle: "You're on a roll! 🎯",
      quizDesc: "You've completed 5 quizzes. Unlock interactive clinical cases to progress even faster.",
      quizFeature: 'Clinical Cases Pro',
      flashcardTitle: 'Great dedication! 📚',
      flashcardDesc: '{{count}} flashcards created! Upgrade to Premium for Express Review and optimize your time.',
      flashcardFeature: 'Express Review',
      streakTitle: '7-day streak! 🔥',
      streakDesc: 'Keep your progress going with advanced statistics and track your evolution in detail.',
      streakFeature: 'Advanced Stats',
      conversationTitle: 'Conversation limit reached 💬',
      conversationDesc: "You've used 4/5 conversations this month. Upgrade to Premium for unlimited conversations.",
      conversationFeature: 'Unlimited Conversations',
      unlock: 'Unlock'
    }
  },
  es: {
    loading: 'Cargando...',
    loadingPage: 'Cargando página...',
    error: 'Error',
    cached: 'En caché',
    searchCount: '{{count}} búsquedas',
    back: 'Volver',
    all: 'Todos',
    save: 'Guardar',
    select: 'Seleccionar',
    delete: 'Eliminar',
    xpEarned: '{{xp}} XP ganados',
    connectionRestored: "Conexión restablecida",
    offlineModeActive: "Modo sin conexión activo",
    limitedFunctionsAvailable: "Funciones limitadas disponibles",
    actionSavedOffline: "Acción guardada sin conexión",
    offlineDataSynced: "{{count}} acción(es) sin conexión sincronizada(s)",
    syncFailed: "Fallo en la sincronización",
    syncingOfflineData: "Sincronizando datos sin conexión",
    offlineDataPending: "Datos sin conexión pendientes de sincronización",
    syncNow: "Sincronizar ahora",
    expandAll: "Expandir todo",
    collapseAll: "Contraer todo",
    edit: "Editar",
    search: "Búsqueda",
    searchInApp: "Buscar en la aplicación",
    preview: "Vista previa",
    saved: "Guardado",
    saving: "Guardando...",
    savedOffline: "Guardado sin conexión",
    lastSaved: "Última vez guardado: {{time}}",
    backToDashboard: "Volver al panel de control",
    home: "Inicio",
    menu: "Menú",
    notificationsLabel: "Notificaciones",
    nav: {
      dashboard: 'Panel de control',
      checklists: 'Listas de verificación'
    },
    settingsMenu: {
      settings: 'Configuración',
      administration: 'Administración',
      themeLight: 'Tema claro',
      themeDark: 'Tema oscuro',
      themeSystem: 'Tema del sistema',
      logout: 'Cerrar sesión',
    },
    sidebar: {
      dashboard: 'Panel de control',
      chatAI: 'Chat IA',
      flashcards: 'Tarjetas',
      revisionSheets: 'Fichas de repaso',
      dailyQuiz: 'Quiz del día',
      study: 'Estudio',
      courses: 'Cursos',
      clinicalCases: 'Casos clínicos',
      challenges: 'Desafíos',
      revisionExpress: 'Repaso Express',
      calculators: 'Calculadoras',
      checklists: 'Checklists',
      medications: 'Medicamentos',
      coding: 'Codificación',
      guidelines: 'Guías',
      forum: 'Foro',
      scores: 'Puntuaciones',
      achievements: 'Logros',
      hallOfFame: 'Hall of Fame',
      settings: 'Configuración',
      groupMain: 'Principal',
      groupLearning: 'Aprendizaje',
      groupTools: 'Herramientas clínicas',
      groupCommunity: 'Comunidad',
    },
    requiredName: {
      title: '👋 ¿Cómo te llamas?',
      description: 'Tu nombre se mostrará en el Hall of Fame y la comunidad. Esta información es obligatoria para continuar.',
      placeholder: 'Dr. Nombre Apellido',
      minChars: 'Mínimo 3 caracteres',
      continue: 'Continuar'
    },
    units: {
      minutes: 'min',
      days: 'd',
      cards: 'tarjetas'
    },
    preparingOfflineContent: "Preparando contenido sin conexión",
    offlineContentReady: "Contenido sin conexión listo",
    downloadOfflineContent: "Descargar contenido sin conexión",
    downloadingEssentialContent: "Descargando contenido esencial...",
    appReadyOffline: "Aplicación lista para uso sin conexión",
    enableOfflineAccess: "Habilitar acceso sin conexión",
    connectToDownload: "Conéctate para descargar",
    downloadComplete: "Descarga completa",
    essentialContentCached: "Contenido esencial en caché",
    downloadFailed: "Fallo en la descarga",
    offlineContent: "Contenido sin conexión",
    cachedItems: "Elementos en caché",
    storageUsed: "Almacenamiento usado",
    offlineStatus: "Estado sin conexión",
    ready: "Listo",
    notReady: "No listo",
    cachedContent: "Contenido en caché",
    manageOfflineContent: "Gestionar contenido sin conexión",
    downloadEssentials: "Descargar lo esencial",
    cleanupOld: "Limpiar antiguos",
    clearAll: "Borrar todo",
    offlineDownloadUnavailable: "Descarga no disponible sin conexión",
    cacheCleared: "Caché limpiado",
    offlineContentRemoved: "Contenido sin conexión eliminado",
    clearFailed: "Fallo al limpiar",
    cleanupComplete: "Limpieza completa",
    oldContentRemoved: "Contenido antiguo eliminado",
    cleanupFailed: "Fallo en la limpieza",
    tryAgainLater: "Inténtalo más tarde",
    cancel: "Cancelar",
    closeDialog: "Cerrar diálogo",
    close: "Cerrar",
    camera: {
      capture: "Capturar",
      takePhoto: "Tomar una foto",
      photoCapture: "Captura de foto"
    },
    copied: "¡Copiado!",
    copyError: "No se pudo copiar",
    shareButton: 'Compartir',
    shared: 'Compartido ✓',
    copy: 'Copiar',
    later: 'Más tarde',
    pricing: 'Precios',
    success: 'Éxito',
    shareExploit: '¡Comparte tu logro con tus colegas!',
    pwa: {
      howToInstall: "Cómo instalar la aplicación:",
      iosInstall: 'Instalación en Safari iOS',
      iosTroubleshoot: 'Si los botones no responden, prueba estas soluciones:',
      tapShare: 'Toca el botón Compartir',
      bottomSafari: 'En la parte inferior de la pantalla en Safari',
      addHomeScreen: 'Desplázate y selecciona "Añadir a pantalla de inicio"',
      scrollDown: 'Desplázate hacia abajo en la lista de opciones',
      tapAdd: 'Toca "Añadir" para confirmar',
      stillNotWorking: 'Si aún no funciona:',
      refreshPage: 'Actualiza la página (desliza hacia abajo)',
      restartSafari: 'Reinicia Safari completamente',
      checkSafari: 'Verifica que estés en Safari (no Chrome iOS)',
      tryPrivate: 'Prueba en modo de navegación privada',
      iconWillAppear: '¡El icono de Sclepios aparecerá en tu pantalla de inicio!',
      tapMenu: 'Toca el menú (3 puntos)',
      selectInstall: 'Selecciona "Instalar aplicación" o "Añadir a pantalla de inicio"',
      confirmInstall: 'Confirma la instalación',
      quickAccess: '¡Acceso rápido desde tu pantalla de inicio!',
      iosInstructionAlert: 'Para instalar la app: Toca el botón Compartir y luego "Añadir a pantalla de inicio"',
      androidInstructionAlert: 'Para instalar la app: Abre el menú del navegador y luego "Añadir a pantalla de inicio"',
      unsupported: "Tu navegador no admite la instalación de aplicaciones web",
      installSclepios: 'Instalar Sclepios',
      installSclepiosAI: 'Instalar Sclepios IA',
      quickAccessNotifications: 'Acceso rápido y notificaciones',
      install: 'Instalar',
      installNow: 'Instalar ahora',
      installDesktopDesc: "Instala la aplicación para acceso rápido y notificaciones.",
      dontShowAgain: 'No mostrar de nuevo'
    },
    followUrgentiste: 'Sigue al Urgentista enmascarado:',
    availableCases: 'Casos clínicos disponibles',
    exploreCases: 'Explora casos clínicos auténticos y su manejo detallado',
    searchCases: 'Buscar por palabra clave, tag o patología...',
    casesFound: '{{count}} caso(s) encontrado(s) para "{{term}}"',
    unexpectedError: "Ocurrió un error",
    saveError: "Error al guardar",
    nameSaved: "¡Nombre guardado!",
    registrationError: "Error al registrar",
    enterName: "Por favor ingresa tu nombre",
    invalidEmail: "Por favor ingresa un email válido",
    enterDifferentEmail: "Por favor ingresa un email diferente",
    emailConfirmSent: "Se ha enviado un email de confirmación a tu nueva dirección. Haz clic en el enlace para confirmar el cambio.",
    emailChangeError: "Error al cambiar el email",
    referralCopied: "¡Enlace de referencia copiado!",
    challengeJoined: "¡Te uniste al desafío!",
    challengeJoinError: "No se pudo unir al desafío",
    selectReason: "Por favor selecciona una razón",
    userBanned: "Usuario baneado exitosamente",
    banError: "Error al banear usuario",
    postDeleted: "Publicación eliminada",
    replyDeleted: "Respuesta eliminada",
    deleteError: "Error al eliminar",
    contentHidden: "Contenido oculto",
    hideError: "Error al ocultar",
    promptCreated: "Prompt creado exitosamente",
    promptCreateError: "Error al crear el prompt",
    promptUpdated: "Prompt actualizado exitosamente",
    promptUpdateError: "Error al actualizar el prompt",
    promptArchived: "Prompt archivado",
    promptArchiveError: "Error al archivar",
    promptDeleteError: "Error al eliminar",
    metricsLoadError: "Error al cargar métricas",
    notifications: {
      streakDanger: "¡Tu racha está en peligro! 🔥",
      streakDangerDesc: "No has estudiado en 2 días. ¡Mantén tu racha!",
      review: "Revisar",
      newGuideline: "Nueva guía disponible 📚",
      guidelineDesc: "{{count}} nueva(s) recomendación(es) en {{specialty}}",
      see: "Ver",
      top5: "¡Estás en el top 5! 🏆",
      top5Desc: "Posición #{{position}} en la clasificación esta semana",
      newBadge: "¡Nuevo logro desbloqueado! 🎉",
      referralSuccess: "¡Un colega se unió a Sclépios gracias a ti! 🎉",
      referralDesc: "¡Gracias por la referencia! Sigue compartiendo."
    },
    patients: {
      loadError: "Error al cargar pacientes",
      loadOneError: "Error al cargar paciente",
    saveError: "Error al guardar",
    usageLoadError: "Error al cargar su uso",
    backgroundTasks: {
      launchError: "No se pudo iniciar la generación",
      generating: "generando...",
      navigateFreely: "Puede navegar libremente",
      aiGenerating: "Generaciones IA en curso",
      flashcards: "Flashcards",
      revisionSheet: "Ficha de revisión",
      qcm: "QCM",
      clinicalCase: "Caso clínico",
      processing: "procesando",
      pending: "pendiente",
    },
    onboarding: {
      completeProfile: "Complete su perfil para continuar",
      welcomeSuccess: "¡Bienvenido! Su perfil ha sido configurado.",
      saveError: "Error al guardar el perfil",
      configTitle: "Configuración de perfil",
      configDesc: "Personalice su experiencia Sclepios",
      previous: "Anterior",
      skip: "Omitir",
      profileRequired: "Perfil requerido",
      next: "Siguiente",
      finalizing: "Finalizando...",
      finish: "Terminar",
      readyToStart: "¡Listo para empezar!",
      readyDesc: "Ya puede usar todas las funcionalidades de Sclepios.",
      medicalAI: "IA Médica",
      adaptiveQuiz: "Quiz adaptativos",
      steps: {
        profile: { title: "Perfil profesional", desc: "Ayúdenos a personalizar su experiencia", fullName: "Nombre completo", fullNamePlaceholder: "Su nombre completo", userType: "Tipo de usuario", selectProfession: "Seleccione su profesión" },
        practice: { title: "Modo de ejercicio", desc: "Describa su entorno de trabajo", mode: "Modo de ejercicio", selectMode: "Seleccione su modo de ejercicio", specialty: "Especialidad", selectSpecialty: "Seleccione su especialidad" },
        service: { title: "Servicio", desc: "¿En qué servicio trabaja?", label: "Servicio", selectService: "Seleccione su servicio" },
        preferences: { title: "Preferencias", desc: "Personalice su experiencia", notifications: "Notificaciones", notificationsDesc: "Reciba notificaciones para flashcards y recordatorios", tips: "Consejos y trucos", tipsDesc: "Reciba consejos para optimizar su uso", newsletterDesc: "Reciba nuestro boletín mensual con novedades" }
      },
      welcomeTitle: '🎉 ¡Bienvenido a Sclépios!',
      welcomeDesc: 'Tu asistente de IA médica personal',
      firstStepBadge: 'Primer Paso',
      chatTitle: '💬 Haz tu primera pregunta',
      chatDesc: 'Prueba la IA médica ahora',
      creatorBadge: 'Creador',
      startIn30s: 'Comienza en 30 segundos',
      tellUsWho: 'Dinos quién eres',
      yourName: 'Tu nombre *',
      specialtyOptional: 'Especialidad (opcional)',
      specialtyPlaceholder: 'Urgencias, Medicina general...',
      rewards: 'Recompensas',
      congrats: '¡Felicidades {{name}}! 🎉',
      badgeEarned: '¡Has desbloqueado la insignia "Primer Paso" y ganado 50 XP!',
      welcomeToast: '🎉 ¡Bienvenido! ¡Has ganado 50 XP!',
      badgeUnlocked: 'Insignia "Primer Paso" desbloqueada',
      readyForQuestion: '¿Listo para tu primera pregunta?',
      askAnything: 'Haz cualquier pregunta médica a la IA',
      example1: '¿Cuáles son los signos de alerta de un infarto?',
      example2: 'Protocolo de manejo de dificultad respiratoria',
      example3: 'Crear flashcards sobre cardiología',
      tip: '💡 Consejo: ¡Ganarás 100 XP y la insignia "Creador" después de tu primera conversación!',
      continue: 'Continuar',
      askFirstQuestion: 'Hacer mi primera pregunta'
    },
      updated: "Paciente actualizado",
      created: "Paciente creado",
      deleted: "Paciente eliminado",
      deleteError: "Error al eliminar"
    },
    photo: {
      unsupportedFormat: "Formato de imagen no soportado. Use PNG, JPEG, WEBP o GIF.",
      tooLarge: "Imagen demasiado grande. Tamaño máximo: 50MB.",
      textDetected: "¡Texto detectado en la imagen!",
      imageAdded: "Imagen añadida - sin texto detectado",
      processingError: "Error al procesar la imagen",
      selectImage: "Por favor seleccione un archivo de imagen",
      cameraError: "Error al procesar la foto",
      takePhoto: "Tomar una foto",
      selectFromGallery: "Seleccionar una imagen"
    },
    documents: {
      unsupportedType: "Tipo de archivo no soportado. Use JPG, PNG, WebP, PDF, TXT o DOCX.",
      tooLarge: "Archivo demasiado grande. Máximo 10MB por archivo.",
      maxFiles: "Máximo 5 archivos permitidos",
      selectAtLeast: "Por favor seleccione al menos un documento",
      ocrNoText: "OCR completado pero no se detectó texto en las imágenes",
      noTextDetected: "No se detectó texto en los documentos. Verifique la calidad e intente \"Forzar OCR PDF\" si es necesario.",
      photoCaptured: "¡Foto capturada con éxito!",
      readError: "Error al leer el archivo {{name}}",
      ocrSuccess: "OCR completo: texto extraído de {{count}} imagen(es)",
      extractionComplete: "Extracción completa. {{count}} archivo(s) procesado(s).",
      importTitle: "Importación de documentos",
      importDesc: "Importe sus documentos para extraer texto automáticamente",
      captureTitle: "Captura de documentos",
      captureDesc: "Tome una foto o seleccione documentos médicos (imágenes, PDF, TXT, DOCX)",
      takePhoto: "Tomar una foto",
      selectFiles: "Seleccionar archivos",
      extracting: "Extrayendo texto...",
      extractText: "Extraer texto ({{count}} archivo{{plural}})",
      formatsSupported: "Formatos soportados: JPG, PNG, WebP, PDF, TXT, DOCX (máx 10MB por archivo)",
      maxFilesInfo: "Máximo 5 archivos por lote",
      pdfInfo: "PDF: detección automática de texto • Imágenes: OCR de alta calidad • TXT/DOCX: extracción directa",
      pdfDetected: "PDF legible detectado: {{count}} caracteres extraídos",
      pdfProcessError: "No se pudo procesar el archivo PDF",
      processingPdf: "Procesando PDF: {{name}}...",
      pdfToOcr: "PDF convertido en imágenes para OCR: {{count}} página(s)",
      extractingImages: "Extrayendo texto de {{count}} imagen(es)...",
      ocrError: "Error OCR: {{message}}",
      forcePdfOcr: "¿PDFs escaneados o de mala calidad? Marque \"Forzar OCR PDF\""
    },
    profile: {
      streakDays: "Días de racha",
      badges: "Insignias",
      shareProfile: "Compartir este perfil",
      joinSclepios: "Únete a Sclépios IA",
      joinDesc: "El asistente médico inteligente para profesionales de la salud",
      createFreeAccount: "Crear una cuenta gratis",
      signoutError: "Error al cerrar sesión"
    },
    admin: {
      costAlerts: {
        title: "Alertas de Costos",
        description: "Monitoreo en tiempo real de costos y ROI",
        testAlert: "Alerta de prueba enviada",
        testAlertError: "Error al enviar alerta de prueba",
        monthlyRevenue: "Ingresos Mensuales",
        aiCosts: "Costos IA",
        margin: "Margen",
        noAlerts: "Sin alertas activas",
        allNormal: "Todos los indicadores están dentro de los límites normales",
        refresh: "Actualizar"
      },
      quickActions: {
        createTemplate: "Crear plantilla rápida",
        templateName: "Nombre de la plantilla",
        templateType: "Tipo",
        templateSubject: "Asunto",
        templateContent: "Contenido",
        templatePlaceholder: "Contenido de la plantilla...",
        createBtn: "Crear plantilla",
        expressCampaign: "Campaña express",
        targetAudience: "Audiencia objetivo",
        allUsers: "Todos los usuarios",
        doctors: "Médicos",
        residents: "Residentes",
        nurses: "Enfermeros",
        emailSubject: "Asunto",
        emailMessage: "Mensaje",
        emailPlaceholder: "Contenido del mensaje...",
        sendNow: "Enviar ahora",
        systemActions: "Acciones del sistema",
        clearCache: "Vaciar caché",
        securityAudit: "Auditoría de seguridad",
        refresh: "Actualizar",
        success: "Éxito",
        templateCreated: "Plantilla creada exitosamente",
        templateCreateError: "No se pudo crear la plantilla",
        fillFields: "Por favor complete el asunto y el contenido",
        campaignSent: "¡Campaña enviada! {{count}} destinatarios",
        campaignSendError: "No se pudo enviar la campaña",
        cacheCleared: "Caché vaciado exitosamente",
        cacheClearError: "No se pudo vaciar el caché",
        auditComplete: "Auditoría completada - Revise los logs para detalles",
        auditError: "No se pudo ejecutar la auditoría de seguridad"
      },
      pushTest: {
        title: "Prueba de notificaciones push",
        description: "Enviar notificaciones push de prueba",
        notifTitle: "Título",
        notifMessage: "Mensaje",
        targetUser: "ID de usuario objetivo (opcional)",
        targetPlaceholder: "Dejar vacío para todos los usuarios",
        sending: "Enviando...",
        sendNotif: "Enviar notificación",
        titlePlaceholder: "Título de la notificación",
        messagePlaceholder: "Cuerpo de la notificación"
      },
      usageStats: {
        period: "Período",
        last24h: "Últimas 24h",
        last7days: "Últimos 7 días",
        last30days: "Últimos 30 días",
        last90days: "Últimos 90 días",
        allTime: "Desde el inicio",
        function: "Función",
        allFunctions: "Todas las funciones",
        loadingStats: "Cargando estadísticas..."
      },
      sendSamples: {
        pageTitle: "Admin · Emails de advertencia",
        title: "Envío de emails de advertencia",
        description: "Esta página envía 3 emails de ejemplo (recordatorio de prueba, advertencia post-prueba, winback) a {{to}}.",
        sent: "Emails de ejemplo enviados a {{to}}",
        error: "Error al enviar",
        status: "Estado"
      }
    },
    paywall: {
      conversationCount: { title: "¡Progresas rápidamente! 🚀", description: "Ya has tenido {{count}} conversaciones con Sclepios AI. Pasa a Premium para continuar sin límites." },
      longExchange: { title: "Discusión profunda 💡", description: "¡Estás en pleno razonamiento clínico! Con Premium, continúa tus intercambios sin interrupción." },
      featureDiscovery: { title: "Función Premium 👑", description: "Desbloquea todo el potencial de Sclepios con Premium.", descriptionWithSpecialty: "Como profesional en {{specialty}}, desbloquea todo el potencial de Sclepios." },
      streakRisk: { title: "¡Protege tu racha! 🔥", description: "Tu racha está en riesgo. Con Premium, recibe recordatorios inteligentes para nunca perder tu progreso." },
      features: {
        unlimitedConversations: "Conversaciones ilimitadas",
        clinicalCases: "Casos clínicos interactivos",
        advancedStats: "Estadísticas avanzadas",
        unlimitedExchanges: "Intercambios ilimitados",
        detailedAnswers: "Respuestas más detalladas",
        priorityAccess: "Acceso prioritario",
        allFeatures: "Todas las funcionalidades",
        advancedAI: "IA médica avanzada",
        optimizedProgress: "Progreso optimizado",
        personalizedReminders: "Recordatorios personalizados",
        detailedStats: "Estadísticas detalladas",
        exclusiveBadges: "Insignias exclusivas"
      },
      viewPremium: "Ver ofertas Premium",
      continueFree: "Continuar gratis",
      trialInfo: "Prueba gratuita de 7 días • Cancelación en cualquier momento"
    },
    patientEdit: {
      updated: "Información del paciente actualizada",
      updateError: "Error al actualizar la información",
      personalInfo: "Información personal",
      years: "años",
      sex: "Sexo",
      editTitle: "Editar información del paciente",
      emergencyContact: "Contacto de emergencia",
      name: "Nombre",
      relationship: "Relación",
      kinship: "Parentesco",
      kinshipPlaceholder: "Cónyuge, Hijo, Padre...",
      lastName: "Apellido",
      firstName: "Nombre",
      selectOption: "Seleccionar",
      male: "Masculino",
      female: "Femenino",
      other: "Otro",
      unspecified: "No especificado"
    },
    photoCapture: {
      cameraError: "Error al acceder a la cámara",
      unsupportedFormat: "Formato de imagen no soportado. Use JPG, PNG, GIF, WebP, HEIC, HEIF o AVIF.",
      tooLarge: "Imagen demasiado grande. Tamaño máximo: 10MB",
      invalidFormat: "Formato de datos inválido",
      extractSuccess: "Texto extraído con éxito ({{count}} caracteres)",
      noTextDetected: "No se detectó texto en la imagen. Verifique que la imagen contenga texto legible.",
      extractError: "Error al extraer el texto",
      takePhoto: "Tomar una foto",
      selectImage: "Seleccionar una imagen"
    },
    structuredList: {
      newItem: "Nuevo elemento",
      addItem: "Agregar un elemento"
    },
    share: {
      copiedToClipboard: "¡Copiado al portapapeles!",
      shareError: "No se pudo compartir",
      quizTitle: "Quiz del día — Sclépios IA",
      quizText: "🩺 ¡Obtuve {{percentage}}% ({{score}}/{{total}}) en el Quiz del día en Sclépios IA! Pon a prueba tus conocimientos médicos 👇",
      streakTitle: "Racha de aprendizaje — Sclépios IA",
      streakText: "{{emoji}} ¡Racha de {{days}} días consecutivos en Sclépios IA! Aprendizaje médico, un día a la vez 💪",
      badgeTitle: "Insignia desbloqueada — Sclépios IA",
      badgeText: "🏅 ¡Desbloqueé la insignia \"{{name}}\" en Sclépios IA! Únete a la comunidad médica 🩺",
      revisionTitle: "Revisión Express — Sclépios IA",
      revisionText: "⚡ Revisión Express completada: {{correct}}/{{total}} ({{accuracy}}%) en Sclépios IA! Modo express para revisar eficientemente 🧠",
      clinicalCaseTitle: "Caso Clínico — Sclépios IA",
      clinicalCaseText: "🏥 ¡Resolví el caso clínico \"{{title}}\" con {{percentage}}% de respuestas correctas ({{score}}/{{total}}) en Sclépios IA! Prueba tú también 👇",
      revisionSheetTitle: "Ficha de revisión — Sclépios IA",
      revisionSheetText: "📋 ¡Generé una ficha de revisión \"{{title}}\" en {{specialty}} en Sclépios IA! IA al servicio del aprendizaje médico 🩺",
      deckText: "📚 ¡Descubre mi deck \"{{name}}\" ({{count}} tarjetas) en Sclépios IA! Revisa eficientemente con flashcards 🧠"
    },
    adminPages: {
      toasts: {
        usersLoadError: "Error al cargar usuarios",
        unauthorized: "Acción no autorizada",
        trialExtended: "Período de prueba extendido 7 días",
        trialExtendError: "Error al extender la prueba",
        userDeleted: "Usuario eliminado exitosamente",
        userDeleteError: "Error al eliminar usuario",
        secretsOk: "✅ Todos los secretos están configurados",
        auditError: "Error al ejecutar la auditoría",
        noMissingUsers: "No se detectaron usuarios faltantes",
        recoverError: "Error al recuperar usuarios",
        stripeSynced: "Datos Stripe sincronizados",
        stripeSyncError: "Error al sincronizar Stripe",
        featureInDev: "Función en desarrollo"
      },
      users: {
        title: "Gestión de Usuarios",
        subtitle: "Gestiona cuentas de usuario, roles y permisos",
        accessDenied: "Acceso no autorizado",
        restricted: "Acceso restringido",
        noPermission: "No tienes los permisos necesarios para acceder a esta página.",
        showDashboard: "Mostrar",
        hideDashboard: "Ocultar",
        dashboard: "Dashboard",
        refresh: "Actualizar",
        verifyConfig: "Verificar config",
        warnInactive: "Avisar inactivos",
        deleteInactive: "Eliminar inactivos",
        userList: "Lista de usuarios",
        manageRolesDesc: "Gestiona los roles y permisos de usuarios",
        loadingUsers: "Cargando usuarios...",
        noUsersFound: "No se encontraron usuarios",
        noName: "Sin nombre",
        user: "Usuario",
        role: "Rol",
        profile: "Perfil",
        subscription: "Suscripción",
        status: "Estado",
        registered: "Registrado",
        actions: "Acciones",
        expiresOn: "Expira el",
        expired: "Expirado",
        notDefined: "No definido",
        revoke: "Revocar",
        activate: "Activar",
        extend: "Extender",
        deleteUser: "Eliminar",
        deleteConfirmTitle: "Eliminar usuario",
        deleteConfirmDesc: "¿Está seguro de que desea eliminar permanentemente a este usuario? Esta acción es irreversible.",
        cancel: "Cancelar",
        auditTitle: "Auditoría de cuentas de usuario",
        auditRefresh: "Actualizar",
        missingAccounts: "{{count}} cuenta(s) faltante(s) detectada(s)",
        noMissing: "No se detectaron cuentas faltantes",
        auditPending: "Auditoría en curso o no disponible...",
        missingDesc: "Algunos usuarios no aparecen en el listado porque no tienen entrada en healthcare_providers.",
        recoverAction: "Haga clic en \"Recuperar\" para restaurarlos automáticamente.",
        recoverBtn: "Recuperar usuarios faltantes",
        allSynced: "✅ Todas las cuentas de usuario están correctamente sincronizadas.",
        clickRefresh: "ℹ️ Haga clic en \"Actualizar\" para ejecutar la auditoría de cuentas.",
        promoCodes: "Códigos promocionales",
        activePromoCodes: "Códigos promo activos",
        promoDesc: "Gestiona códigos de descuento para tus usuarios",
        createCode: "Crear código",
        noPromoCodes: "No hay códigos promocionales creados",
        promoComingSoon: "Esta función estará disponible pronto",
        premiumFree: "Premium Gratuito",
        freeTrial: "Prueba gratuita",
        trialExpired: "Prueba expirada",
        free: "Gratuito",
        warningsSent: "{{count}} avisos enviados",
        accountsDeleted: "{{count}} cuentas eliminadas",
        cleanupError: "Error al limpiar usuarios inactivos",
        missingSecrets: "Secretos faltantes: {{missing}}",
        configCheckError: "Error al verificar config",
        usersRecovered: "{{count}} usuario(s) recuperado(s)",
        confirmDeletePrompt: "¿Está seguro de que desea eliminar permanentemente al usuario {{name}}? Esta acción es irreversible.",
        proProfile: "Perfil Pro",
        trialStatus: "Estado prueba",
      }
    },
    pwaPrompt: {
      description: "Active las notificaciones para recibir alertas importantes sobre sus flashcards y recordatorios de estudio.",
      privacyNote: "Seguro y respetuoso con su privacidad",
      enable: "Activar",
      enabling: "Activando...",
      later: "Más tarde",
    },
    emptyStates: {
      conversations: { title: 'Sin conversaciones', description: 'Inicie una nueva conversación con la IA médica.', actionLabel: 'Nueva conversación' },
      flashcards: { title: 'Sin flashcards', description: 'Cree sus primeras flashcards para empezar a repasar eficazmente.', actionLabel: 'Crear flashcards' },
      forum: { title: 'Sin discusiones', description: 'Sea el primero en iniciar una discusión en esta categoría.', actionLabel: 'Crear un post' },
      patients: { title: 'Sin pacientes', description: 'No hay pacientes registrados en el sistema.', actionLabel: 'Agregar un paciente' },
      settings: { title: 'Configuración requerida', description: 'Configure sus preferencias para personalizar su experiencia.', actionLabel: 'Configurar' },
      generic: { title: 'Sin elementos', description: 'No hay nada que mostrar por el momento.', actionLabel: 'Actualizar' }
    },
    seo: {
      home: { title: 'Sclépios IA - Asistente médico', desc: 'Asistente IA médico: chat, formación, repaso, comunidad.' },
      dashboard: { title: 'Panel de control - Sclépios IA', desc: 'Su panel de control: actividades, repasos, suscripciones.' },
      auth: { title: 'Conexión / Registro - Sclépios IA', desc: 'Acceda a su espacio seguro Sclépios IA.' },
      chat: { title: 'Chat médico - Sclépios IA', desc: 'Charle con la IA médica: análisis, diagnósticos, formación.' },
      study: { title: 'Espacio de estudio - Sclépios IA', desc: 'Recursos y entrenamientos para progresar en medicina.' },
      community: { title: 'Comunidad médica - Sclépios IA', desc: 'Comparta e intercambie con la comunidad Sclépios.' },
      flashcards: { title: 'Flashcards médicas - Sclépios IA', desc: 'Repase eficazmente con flashcards generadas por IA.' },
      revisionSheets: { title: 'Fichas de repaso - Sclépios IA', desc: 'Fichas sintéticas para repasar conceptos esenciales.' },
      calculator: { title: 'Calculadora médica - Sclépios IA', desc: 'Herramientas de cálculo y puntuaciones clínicas fiables.' },
      checklists: { title: 'Checklists clínicas - Sclépios IA', desc: 'Procedimientos y checklists para una práctica segura.' },
      guidelines: { title: 'Guías médicas - Sclépios IA', desc: 'Recomendaciones y buenas prácticas actualizadas.' },
      quiz: { title: 'Quiz médico - Sclépios IA', desc: 'Pruebe sus conocimientos con quizzes IA.' },
      dailyQuiz: { title: 'Quiz del día - Sclépios IA', desc: 'Un quiz diario para mantener sus conocimientos.' },
      scores: { title: 'Puntuaciones y rendimiento - Sclépios IA', desc: 'Siga su progreso y objetivos de aprendizaje.' },
      medications: { title: 'Medicamentos y RCP - Sclépios IA', desc: 'Búsqueda y análisis de RCP con IA.' },
      coding: { title: 'Coding y prompts - Sclépios IA', desc: 'Taller de prompts y herramientas de código asistido.' },
      rss: { title: 'Vigilancia científica (RSS) - Sclépios IA', desc: 'Siga las noticias médicas y científicas seleccionadas.' },
      settings: { title: 'Ajustes y suscripción - Sclépios IA', desc: 'Perfil, seguridad, notificaciones y facturación.' },
      notFound: { title: 'Página no encontrada - Sclépios IA', desc: 'La página solicitada no existe o ha sido movida.' },
      admin: { title: 'Administración - Sclépios IA', desc: 'Herramientas de administración Sclépios IA.' },
      adminDashboard: { title: 'Admin - Panel de control', desc: 'Visión general de métricas y controles de administración.' },
      adminUsage: { title: 'Admin - Estadísticas de uso', desc: 'Costos, consultas y modelos utilizados.' },
      adminPrompts: { title: 'Admin - Prompts IA', desc: 'Gestión y revisión de prompts del servidor.' },
      adminNotifications: { title: 'Admin - Notificaciones', desc: 'Campañas y ajustes de notificaciones.' },
      adminUsers: { title: 'Admin - Usuarios', desc: 'Gestión de usuarios y suscripciones.' },
      adminLogs: { title: 'Admin - Logs del sistema', desc: 'Eventos de seguridad y actividad.' },
      adminPushDebug: { title: 'Admin - Debug Push', desc: 'Diagnósticos de notificaciones push.' },
      adminSamples: { title: 'Admin - Envío de muestras', desc: 'Envío de ejemplos de emails/notificaciones.' },
      features: { title: 'Funcionalidades — Sclépios IA', desc: 'Descubra todas las funcionalidades del asistente médico IA: chat, calculadoras, flashcards, quizzes y casos clínicos.' },
      articles: { title: 'Artículos médicos — Sclépios IA', desc: 'Artículos médicos escritos por profesionales de la salud.' },
      articlePost: { title: 'Artículo médico — Sclépios IA', desc: 'Artículo médico detallado con referencias y puntos clave.' },
      aboutDoctor: { title: 'Acerca de — Dr Galindo | Sclépios IA', desc: 'Conozca al creador de Sclépios IA, médico de urgencias y desarrollador.' },
      fallback: { title: 'Sclépios IA', desc: 'Asistente IA médico: chat, repaso, comunidad.' }
    },
    medication: {
      noName: 'Medicamento sin nombre',
      add: 'Agregar',
      noMedication: 'Ningún medicamento agregado',
      clickToEdit: 'Clic para modificar',
      name: 'Nombre del medicamento',
      dosage: 'Dosificación',
      unit: 'Unidad',
      frequency: 'Frecuencia',
      route: 'Vía'
    },
    moderation: {
      moderate: 'Moderar',
      actions: 'Acciones de moderación',
      hideContent: 'Ocultar contenido',
      deletePermanently: 'Eliminar definitivamente',
      banUser: 'Banear usuario',
      banTitle: 'Banear usuario',
      deleteTitle: 'Eliminar contenido',
      banDesc: 'Esta acción baneará al usuario de la comunidad. Indique la razón del baneo.',
      deleteDesc: 'Esta acción eliminará definitivamente el contenido. Esta acción es irreversible.',
      banReason: 'Razón del baneo',
      selectReason: 'Seleccione una razón',
      spam: 'Spam repetido',
      harassment: 'Acoso',
      inappropriate: 'Contenido inapropiado',
      misinformation: 'Desinformación médica grave',
      privacy: 'Violación grave de privacidad',
      other: 'Otro',
      banDuration: 'Duración del baneo',
      selectDuration: 'Seleccione la duración',
      days7: '7 días',
      days30: '30 días',
      days90: '90 días',
      permanent: 'Permanente',
      banning: 'Baneando...',
      ban: 'Banear',
      warning: 'Atención: Acción irreversible',
      warningDesc: 'El contenido será eliminado definitivamente y no podrá ser recuperado.',
      deleting: 'Eliminando...',
      deleteConfirm: 'Eliminar definitivamente'
    },
    rss: {
      statsTitle: 'Estadísticas RSS',
      subscribedFeeds: 'Feeds suscritos',
      unread: 'No leídas',
      favorites: 'Favoritos',
      readThisWeek: 'Leídos esta semana',
      customFeeds: 'Feeds personalizados',
      globalActivity: 'Actividad global',
      veryActive: 'Muy activo',
      active: 'Activo',
      lowActive: 'Poco activo'
    },
    premium: {
      upgradeTo: 'Pase a Premium',
      unlockAll: 'Desbloquee todas las funcionalidades: casos clínicos, revisión express, estadísticas avanzadas...',
      seeOffers: 'Ver las ofertas'
    },
    hallOfFame: {
      youAre: 'Usted es #{{rank}}',
      congrats: '🎉 ¡Felicidades! Está en el podio (#{{rank}})',
      seeCategories: 'Ver las categorías de excelencia',
      you: '(usted)'
    },
    consultations: {
      history: 'Anterioridades',
      noConsultation: 'Ninguna consulta registrada para este paciente',
      createFirst: 'Crear la primera consulta',
      noStructuredElements: 'Ningún elemento estructurado en la última consulta',
      lastConsultation: 'Última consulta',
      newConsultation: 'Nueva consulta',
      antecedents: 'Antecedentes',
      medical: 'Médicos',
      surgical: 'Quirúrgicos',
      treatments: 'Tratamientos habituales',
      lifestyle: 'Estilo de vida',
      autoFillNote: 'Estos elementos serán automáticamente pre-rellenados en las nuevas consultas',
      medication: 'Medicamento',
      lifestyleElement: 'Elemento estilo de vida'
    },
    studyStats: {
      noReviewPeriod: 'Ninguna revisión en este período',
      startReviewing: 'Comience a revisar para ver sus estadísticas',
      noCardsCreated: 'Ninguna tarjeta creada',
      createFirstCards: 'Cree sus primeras flashcards para seguir su progresión',
      totalCards: 'tarjetas',
      days7: '7 días',
      days30: '30 días',
      days90: '90 días'
    },
    upgrade: {
      quizTitle: '¡Estás en racha! 🎯',
      quizDesc: 'Has completado 5 quizzes. Desbloquea los casos clínicos interactivos para progresar aún más rápido.',
      quizFeature: 'Casos Clínicos Pro',
      flashcardTitle: '¡Gran dedicación! 📚',
      flashcardDesc: '¡{{count}} flashcards creadas! Pasa a Premium para acceder a Revisión Express y optimizar tu tiempo.',
      flashcardFeature: 'Revisión Express',
      streakTitle: '¡7 días de racha! 🔥',
      streakDesc: 'Mantén tu progreso con las estadísticas avanzadas y sigue tu evolución en detalle.',
      streakFeature: 'Stats Avanzadas',
      conversationTitle: 'Límite de conversaciones alcanzado 💬',
      conversationDesc: 'Has usado 4/5 conversaciones este mes. Pasa a Premium para conversaciones ilimitadas.',
      conversationFeature: 'Conversaciones ilimitadas',
      unlock: 'Desbloquear'
    }
  }
};